<template>
  <main style="z-index: 9999999999999" class="pl-10 pt-5 non-print-slip">
    <div
      class="
        md:inline-flex
        relative
        h-8
        items-center
        justify-center
        w-8
        -ml-2
        hidden
      "
      id="sidebar-switch"
    >
      <svg
        v-if="!active"
        @click="toggle"
        class="w-5 h-5 cursor-pointer absolute hidden md:block"
        viewBox="0 0 25 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.425293" width="15" height="2.5" rx="1.25" fill="#253B95" />
        <rect y="7.92529" width="21" height="2.5" rx="1.25" fill="#253B95" />
        <rect y="15.4253" width="25" height="2.5" rx="1.25" fill="#253B95" />
      </svg>
      <svg
        v-else
        @click="toggle"
        class="w-4 h-4 cursor-pointer absolute"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.2 2L2 21.2"
          stroke="#979797"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 2L21.2 21.2"
          stroke="#979797"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <!-- <div v-if="!active" class="mt-16"> -->
    <div
      :class="!active ? 'hidden md:block' : 'block md:hidden'"
      class="mt-16 class flex flex-col justify-center items-center -ml-10"
    >
      <div class="mt-6 flex justify-center">
        <router-link :to="{ name: 'Dashboard' }">
          <svg
            height="30px"
            width="30px"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6C0 2.68629 2.68629 0 6 0H24C27.3137 0 30 2.68629 30 6V24C30 27.3137 27.3137 30 24 30H6C2.68629 30 0 27.3137 0 24V6Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 13.25L14.75 8L21.5 13.25V21.5C21.5 22.3284 20.8284 23 20 23H9.5C8.67157 23 8 22.3284 8 21.5V13.25Z"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 23V15.5H17V23"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p class="tiny text-center mt-1 text-gray-700">Home</p>
        </router-link>
      </div>
      <div class="mt-6">
        <router-link
          class="flex items-center flex-col"
          :to="{ name: 'Payments' }"
        >
          <svg
            height="30px"
            width="30px"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6.24237C0 2.92866 2.68629 0.242371 6 0.242371H24C27.3137 0.242371 30 2.92866 30 6.24237V24.2424C30 27.5561 27.3137 30.2424 24 30.2424H6C2.68629 30.2424 0 27.5561 0 24.2424V6.24237Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8694 7.35107C9.83777 7.37018 9.00002 8.19014 9.00002 9.22582V21.8377C8.99915 21.8992 9.03144 21.9564 9.08453 21.9874C9.12018 22.0082 9.1615 22.015 9.20088 22.0079C9.20518 22.0081 9.2095 22.0082 9.21385 22.0082H18.3737C18.4679 22.0082 18.5442 21.9319 18.5442 21.8377V15.1909H21.7824C21.8765 15.1909 21.9528 15.1146 21.9528 15.0205V9.22582C21.9528 8.19016 21.1137 7.35107 20.0781 7.35107H10.8748H10.8694ZM18.2033 21.6673H9.34088V9.22582C9.34088 8.37493 10.0209 7.71051 10.8748 7.69194H10.8801H18.9969C18.5173 8.03265 18.2033 8.59288 18.2033 9.22582V21.6673ZM21.6119 9.22582V14.8501H18.5442V9.22582C18.5442 8.43948 19.1234 7.79798 19.881 7.70259C19.8974 7.70135 19.9135 7.69777 19.9289 7.69194H20.0781C20.9308 7.69194 21.6119 8.3731 21.6119 9.22582ZM10.8428 16.7248C10.7487 16.7336 10.6795 16.8171 10.6884 16.9112C10.6972 17.0053 10.7806 17.0745 10.8748 17.0657H16.6694C16.7309 17.0665 16.7881 17.0342 16.8191 16.9812C16.85 16.9281 16.85 16.8624 16.8191 16.8093C16.7881 16.7562 16.7309 16.7239 16.6694 16.7248H10.8748C10.8641 16.7238 10.8534 16.7238 10.8428 16.7248ZM10.6884 19.2973C10.6795 19.2031 10.7487 19.1197 10.8428 19.1108C10.8534 19.1098 10.8641 19.1098 10.8748 19.1108H13.2608C13.3223 19.11 13.3794 19.1423 13.4104 19.1954C13.4414 19.2484 13.4414 19.3141 13.4104 19.3672C13.3794 19.4203 13.3223 19.4526 13.2608 19.4517H10.8748C10.7806 19.4605 10.6972 19.3914 10.6884 19.2973Z"
              fill="#253B95"
            />
            <path
              d="M10.8694 7.35107V7.09853L10.8648 7.09862L10.8694 7.35107ZM9.00002 21.8377L9.25252 21.8413V21.8377H9.00002ZM9.08453 21.9874L8.95725 22.2054L8.95725 22.2054L9.08453 21.9874ZM9.20088 22.0079L9.21647 21.7558L9.18594 21.754L9.15584 21.7594L9.20088 22.0079ZM9.21385 22.0082V21.7557L9.21031 21.7557L9.21385 22.0082ZM18.3737 22.0082V22.2607H18.3738L18.3737 22.0082ZM18.5442 21.8377L18.7967 21.8378V21.8377H18.5442ZM18.5442 15.1909V14.9384H18.2917V15.1909H18.5442ZM21.7824 15.1909V15.4434H21.7824L21.7824 15.1909ZM21.9528 15.0205L22.2053 15.0205V15.0205H21.9528ZM9.34088 21.6673H9.08838V21.9198H9.34088V21.6673ZM18.2033 21.6673V21.9198H18.4558V21.6673H18.2033ZM10.8748 7.69194V7.43938L10.8693 7.4395L10.8748 7.69194ZM18.9969 7.69194L19.1431 7.89779L19.7883 7.43944H18.9969V7.69194ZM21.6119 14.8501V15.1026H21.8644V14.8501H21.6119ZM18.5442 14.8501H18.2917V15.1026H18.5442V14.8501ZM19.881 7.70259L19.862 7.45049L19.8495 7.45207L19.881 7.70259ZM19.9289 7.69194V7.43944H19.8827L19.8395 7.45581L19.9289 7.69194ZM10.8428 16.7248L10.8664 16.9762L10.8665 16.9762L10.8428 16.7248ZM10.8748 17.0657V16.8132H10.863L10.8512 16.8143L10.8748 17.0657ZM16.6694 17.0657L16.673 16.8132H16.6694V17.0657ZM16.8191 16.9812L17.0371 17.1084L17.0371 17.1084L16.8191 16.9812ZM16.8191 16.8093L17.0371 16.682L17.0371 16.682L16.8191 16.8093ZM16.6694 16.7248V16.9773L16.673 16.9773L16.6694 16.7248ZM10.8748 16.7248L10.8511 16.9762L10.8629 16.9773H10.8748V16.7248ZM10.8428 19.1108L10.8664 19.3622L10.8665 19.3622L10.8428 19.1108ZM10.8748 19.1108L10.8511 19.3622L10.8629 19.3633H10.8748V19.1108ZM13.2608 19.1108V19.3634L13.2644 19.3633L13.2608 19.1108ZM13.4104 19.1954L13.1923 19.3226L13.1923 19.3226L13.4104 19.1954ZM13.4104 19.3672L13.6285 19.4945V19.4945L13.4104 19.3672ZM13.2608 19.4517L13.2644 19.1992H13.2608V19.4517ZM10.8748 19.4517V19.1992H10.863L10.8512 19.2003L10.8748 19.4517ZM9.25252 9.22582C9.25252 8.33319 9.97456 7.62019 10.8741 7.60353L10.8648 7.09862C9.70097 7.12017 8.74752 8.04709 8.74752 9.22582H9.25252ZM9.25252 21.8377V9.22582H8.74752V21.8377H9.25252ZM9.21181 21.7693C9.23736 21.7842 9.25291 21.8117 9.25249 21.8413L8.74754 21.8342C8.74539 21.9867 8.82552 22.1286 8.95725 22.2054L9.21181 21.7693ZM9.15584 21.7594C9.17469 21.756 9.19461 21.7593 9.21181 21.7693L8.95725 22.2054C9.04575 22.2571 9.14831 22.274 9.24592 22.2563L9.15584 21.7594ZM9.21031 21.7557C9.21237 21.7557 9.21443 21.7557 9.21647 21.7558L9.18528 22.2599C9.19592 22.2605 9.20664 22.2608 9.2174 22.2607L9.21031 21.7557ZM18.3737 21.7557H9.21385V22.2607H18.3737V21.7557ZM18.2917 21.8377C18.2917 21.7924 18.3284 21.7557 18.3737 21.7557L18.3738 22.2607C18.6073 22.2607 18.7967 22.0713 18.7967 21.8378L18.2917 21.8377ZM18.2917 15.1909V21.8377H18.7967V15.1909H18.2917ZM21.7824 14.9384H18.5442V15.4434H21.7824V14.9384ZM21.7003 15.0205C21.7003 14.9752 21.737 14.9384 21.7823 14.9384L21.7824 15.4434C22.016 15.4434 22.2053 15.2541 22.2053 15.0205L21.7003 15.0205ZM21.7003 9.22582V15.0205H22.2053V9.22582H21.7003ZM20.0781 7.60357C20.9743 7.60357 21.7003 8.32961 21.7003 9.22582H22.2053C22.2053 8.05071 21.2532 7.09857 20.0781 7.09857V7.60357ZM10.8748 7.60357H20.0781V7.09857H10.8748V7.60357ZM10.8694 7.60357H10.8748V7.09857H10.8694V7.60357ZM9.34088 21.9198H18.2033V21.4148H9.34088V21.9198ZM9.08838 9.22582V21.6673H9.59338V9.22582H9.08838ZM10.8693 7.4395C9.88501 7.46091 9.08838 8.23088 9.08838 9.22582H9.59338C9.59338 8.51899 10.1569 7.96011 10.8803 7.94438L10.8693 7.4395ZM10.8801 7.43944H10.8748V7.94444H10.8801V7.43944ZM18.9969 7.43944H10.8801V7.94444H18.9969V7.43944ZM18.4558 9.22582C18.4558 8.67837 18.7271 8.19333 19.1431 7.89779L18.8507 7.48609C18.3074 7.87197 17.9508 8.50738 17.9508 9.22582H18.4558ZM18.4558 21.6673V9.22582H17.9508V21.6673H18.4558ZM21.8644 14.8501V9.22582H21.3594V14.8501H21.8644ZM18.5442 15.1026H21.6119V14.5976H18.5442V15.1026ZM18.2917 9.22582V14.8501H18.7967V9.22582H18.2917ZM19.8495 7.45207C18.9664 7.56326 18.2917 8.31143 18.2917 9.22582H18.7967C18.7967 8.56753 19.2804 8.0327 19.9125 7.95311L19.8495 7.45207ZM19.8395 7.45581C19.8467 7.45307 19.8543 7.45138 19.862 7.4508L19.9 7.95437C19.9405 7.95132 19.9804 7.94246 20.0184 7.92806L19.8395 7.45581ZM20.0781 7.43944H19.9289V7.94444H20.0781V7.43944ZM21.8644 9.22582C21.8644 8.23365 21.0702 7.43944 20.0781 7.43944V7.94444C20.7913 7.94444 21.3594 8.51255 21.3594 9.22582H21.8644ZM10.9398 16.8876C10.9439 16.9324 10.9111 16.972 10.8664 16.9762L10.8192 16.4734C10.5863 16.4952 10.4151 16.7018 10.437 16.9348L10.9398 16.8876ZM10.8512 16.8143C10.8959 16.8101 10.9356 16.8429 10.9398 16.8876L10.437 16.9348C10.4588 17.1677 10.6654 17.3389 10.8983 17.3171L10.8512 16.8143ZM16.6694 16.8132H10.8748V17.3182H16.6694V16.8132ZM16.601 16.8539C16.6159 16.8283 16.6434 16.8128 16.673 16.8132L16.6659 17.3181C16.8184 17.3203 16.9602 17.2402 17.0371 17.1084L16.601 16.8539ZM16.601 16.9366C16.5861 16.911 16.5861 16.8794 16.601 16.8539L17.0371 17.1084C17.114 16.9767 17.114 16.8138 17.0371 16.682L16.601 16.9366ZM16.673 16.9773C16.6434 16.9777 16.6159 16.9622 16.601 16.9366L17.0371 16.682C16.9602 16.5503 16.8184 16.4702 16.6659 16.4723L16.673 16.9773ZM10.8748 16.9773H16.6694V16.4723H10.8748V16.9773ZM10.8665 16.9762C10.8614 16.9767 10.8562 16.9767 10.8511 16.9762L10.8984 16.4734C10.8721 16.4709 10.8455 16.4709 10.8191 16.4734L10.8665 16.9762ZM10.8192 18.8594C10.5863 18.8813 10.4151 19.0879 10.437 19.3208L10.9398 19.2737C10.9439 19.3184 10.9111 19.358 10.8664 19.3622L10.8192 18.8594ZM10.8984 18.8595C10.8721 18.857 10.8455 18.857 10.8191 18.8595L10.8665 19.3622C10.8614 19.3627 10.8562 19.3627 10.8511 19.3622L10.8984 18.8595ZM13.2608 18.8583H10.8748V19.3633H13.2608V18.8583ZM13.6285 19.0681C13.5516 18.9363 13.4097 18.8562 13.2572 18.8584L13.2644 19.3633C13.2348 19.3637 13.2073 19.3482 13.1923 19.3226L13.6285 19.0681ZM13.6285 19.4945C13.7054 19.3627 13.7054 19.1998 13.6285 19.0681L13.1923 19.3226C13.1774 19.2971 13.1774 19.2655 13.1923 19.2399L13.6285 19.4945ZM13.2572 19.7042C13.4097 19.7063 13.5516 19.6262 13.6285 19.4945L13.1923 19.2399C13.2073 19.2144 13.2348 19.1988 13.2644 19.1992L13.2572 19.7042ZM10.8748 19.7042H13.2608V19.1992H10.8748V19.7042ZM10.437 19.3208C10.4588 19.5538 10.6654 19.7249 10.8983 19.7031L10.8512 19.2003C10.8959 19.1961 10.9356 19.229 10.9398 19.2737L10.437 19.3208Z"
              fill="#253B95"
            />
            <path
              d="M12.8838 14.2705V11.5763C12.8838 11.3627 13.1695 11.2913 13.2699 11.4798L14.5746 13.9276C14.675 14.1161 14.9607 14.0454 14.9607 13.8319C14.9607 13.0517 14.9607 11.8702 14.9607 10.9914"
              stroke="#253B95"
              stroke-width="0.4"
            />
            <rect x="12" y="13.0954" width="4" height="0.4" fill="#253B95" />
            <rect x="12" y="12.1723" width="4" height="0.4" fill="#253B95" />
          </svg>
          <p class="tiny text-center mt-1 text-gray-700">Payments</p>
        </router-link>
      </div>
      <div class="mt-6">
        <router-link class="flex items-center flex-col" :to="{ name: 'Pos' }">
          <svg
            height="30px"
            width="30px"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6C0 2.68629 2.68629 0 6 0H42C45.3137 0 48 2.68629 48 6V42C48 45.3137 45.3137 48 42 48H6C2.68629 48 0 45.3137 0 42V6Z"
              fill="#EFFAFF"
            />
            <path
              d="M29.1221 13.4069C29.1221 13.5538 29.1221 13.7008 29.1221 13.8477C29.1221 14.2537 29.1221 14.6596 29.1221 15.0656C29.1221 15.6733 29.1221 16.281 29.1221 16.8887C29.1221 17.6483 29.1221 18.4104 29.1221 19.17C29.1221 20.0218 29.1221 20.8736 29.1221 21.7254C29.1221 22.617 29.1221 23.5086 29.1221 24.4027C29.1221 25.2844 29.1221 26.1685 29.1221 27.0502C29.1221 27.8621 29.1221 28.6716 29.1221 29.4835C29.1221 30.1759 29.1221 30.8657 29.1221 31.5581C29.1221 32.0712 29.1221 32.5817 29.1221 33.0948C29.1221 33.3762 29.1221 33.6577 29.1221 33.9416C29.1221 33.979 29.1221 34.0163 29.1221 34.0562C29.1221 34.0736 29.1121 34.2081 29.1196 34.1259C29.127 34.0487 29.1096 34.1533 29.1046 34.1732C29.0996 34.1931 29.0897 34.2156 29.0847 34.2355C29.0722 34.2903 29.0971 34.1882 29.1046 34.1907C29.1071 34.1931 29.0448 34.2953 29.0399 34.3027C28.995 34.3774 29.1021 34.243 29.0399 34.3027C29.0175 34.3251 28.995 34.3476 28.9726 34.37C28.9054 34.4372 28.995 34.3451 28.9975 34.3525C28.9975 34.3525 28.9602 34.3774 28.9577 34.3799C28.9427 34.3874 28.9303 34.3974 28.9153 34.4048C28.9054 34.4098 28.8954 34.4148 28.8879 34.4198C28.8481 34.4372 28.8506 34.4397 28.8879 34.4223C28.8879 34.4098 28.9427 34.4048 28.8879 34.4223C28.873 34.4273 28.8581 34.4322 28.8406 34.4372C28.8257 34.4422 28.8082 34.4447 28.7933 34.4497C28.7535 34.4621 28.7261 34.4397 28.8282 34.4497C28.7958 34.4472 28.7584 34.4547 28.7261 34.4547C28.7211 34.4547 28.7161 34.4547 28.7111 34.4547C28.4521 34.4571 28.1956 34.4547 27.9365 34.4547C27.3687 34.4547 26.7984 34.4547 26.2305 34.4547C25.451 34.4547 24.6714 34.4547 23.8919 34.4547C23.0127 34.4547 22.1335 34.4547 21.2544 34.4547C20.3752 34.4547 19.4985 34.4547 18.6193 34.4547C17.8423 34.4547 17.0652 34.4547 16.2882 34.4547C15.7253 34.4547 15.1599 34.4547 14.5971 34.4547C14.3455 34.4547 14.094 34.4571 13.8424 34.4547C13.8374 34.4547 13.835 34.4547 13.83 34.4547C13.8125 34.4547 13.7951 34.4547 13.7777 34.4522C13.6631 34.4447 13.8449 34.4771 13.7602 34.4497C13.7304 34.4397 13.698 34.4322 13.6656 34.4223C13.6108 34.4073 13.6656 34.4123 13.6656 34.4223C13.7054 34.4397 13.7054 34.4397 13.6656 34.4198C13.6556 34.4148 13.6457 34.4098 13.6382 34.4048C13.6307 34.3999 13.556 34.355 13.556 34.3525C13.561 34.3451 13.6482 34.4372 13.5809 34.37C13.571 34.3575 13.5585 34.3476 13.5461 34.3376C13.5336 34.3251 13.5236 34.3152 13.5137 34.3027C13.4813 34.2728 13.4888 34.2953 13.5112 34.3027C13.5411 34.3127 13.5336 34.3401 13.5112 34.3027C13.4987 34.2803 13.4838 34.2554 13.4688 34.233C13.4664 34.2305 13.4464 34.1907 13.4464 34.1907C13.4514 34.1882 13.4788 34.2878 13.4664 34.2355C13.4564 34.2006 13.4439 34.1608 13.434 34.1259C13.4066 34.0412 13.434 34.218 13.4315 34.1259C13.4315 34.1035 13.429 34.0811 13.429 34.0562C13.429 34.0163 13.429 33.974 13.429 33.9341C13.429 33.6477 13.429 33.3613 13.429 33.0749C13.429 32.5568 13.429 32.0363 13.429 31.5183C13.429 30.8259 13.429 30.136 13.429 29.4436C13.429 28.6267 13.429 27.8098 13.429 26.9954C13.429 26.1162 13.429 25.2371 13.429 24.3579C13.429 23.4663 13.429 22.5746 13.429 21.683C13.429 20.8288 13.429 19.9745 13.429 19.1202C13.429 18.3656 13.429 17.611 13.429 16.8563C13.429 16.2486 13.429 15.6434 13.429 15.0357C13.429 14.6372 13.429 14.2362 13.429 13.8377C13.429 13.6734 13.424 13.509 13.4315 13.3446C13.434 13.2649 13.439 13.3795 13.4265 13.377C13.4265 13.377 13.4365 13.3322 13.4365 13.3297C13.4464 13.2998 13.4589 13.2674 13.4664 13.235C13.4788 13.1802 13.4539 13.2823 13.4464 13.2799C13.4464 13.2799 13.4713 13.23 13.4763 13.2226C13.4838 13.2076 13.4938 13.1952 13.5012 13.1802C13.5062 13.1703 13.5137 13.1628 13.5187 13.1528C13.5336 13.1304 13.5311 13.1354 13.5087 13.1653C13.4838 13.1728 13.4788 13.1977 13.5112 13.1653C13.5261 13.1503 13.5411 13.1329 13.556 13.1205C13.566 13.1105 13.5809 13.1005 13.5909 13.0881C13.6258 13.0457 13.556 13.123 13.5535 13.1155C13.551 13.1105 13.6382 13.0632 13.6482 13.0557C13.6507 13.0532 13.6905 13.0333 13.6905 13.0333C13.693 13.0383 13.5834 13.0682 13.6606 13.0457C13.6955 13.0358 13.7378 13.0308 13.7727 13.0159C13.8175 12.9959 13.7328 13.0208 13.7229 13.0208C13.7378 13.0233 13.7578 13.0183 13.7727 13.0159C13.7901 13.0159 13.8076 13.0134 13.825 13.0134C13.83 13.0134 13.8374 13.0134 13.8424 13.0134C13.9296 13.0134 14.0193 13.0134 14.1064 13.0134C14.5398 13.0134 14.9707 13.0134 15.404 13.0134C16.0939 13.0134 16.7813 13.0134 17.4712 13.0134C18.318 13.0134 19.1648 13.0134 20.0091 13.0134C20.9007 13.0134 21.7923 13.0134 22.6839 13.0134C23.5208 13.0134 24.3576 13.0134 25.1944 13.0134C25.8744 13.0134 26.5568 13.0134 27.2367 13.0134C27.6526 13.0134 28.0661 13.0134 28.482 13.0134C28.5567 13.0134 28.6339 13.0134 28.7086 13.0134C28.7136 13.0134 28.7161 13.0134 28.7211 13.0134C28.7335 13.0134 28.731 13.0134 28.7559 13.0134C28.7734 13.0134 28.7908 13.0159 28.8058 13.0159C28.863 13.0183 28.7559 13.0134 28.7559 13.0109C28.7559 13.0084 28.8655 13.0383 28.868 13.0408C28.8705 13.0408 28.9153 13.0557 28.9153 13.0582C28.9128 13.0682 28.8257 13.0084 28.8705 13.0408C28.9004 13.0607 28.9378 13.0781 28.9676 13.098C29.0424 13.1429 28.9079 13.0358 28.9676 13.098C28.9925 13.123 29.0199 13.1553 29.0448 13.1777C29.0872 13.2126 29.01 13.1429 29.0175 13.1404C29.0175 13.1404 29.0424 13.1777 29.0448 13.1802C29.0498 13.1902 29.1021 13.2774 29.0996 13.2774C29.0947 13.2799 29.0673 13.1802 29.0797 13.2325C29.0847 13.2475 29.0897 13.2624 29.0947 13.2799C29.0971 13.2873 29.1196 13.377 29.1196 13.377C29.1046 13.3795 29.1146 13.2649 29.1146 13.3446C29.1196 13.362 29.1221 13.3845 29.1221 13.4069C29.127 13.6684 29.3487 13.9174 29.6202 13.905C29.8867 13.8925 30.1233 13.6858 30.1183 13.4069C30.1033 12.6398 29.4907 12.0246 28.7236 12.0146C28.6588 12.0146 28.5965 12.0146 28.5318 12.0146C28.1308 12.0146 27.7273 12.0146 27.3264 12.0146C26.6514 12.0146 25.979 12.0146 25.304 12.0146C24.4597 12.0146 23.6154 12.0146 22.7711 12.0146C21.867 12.0146 20.963 12.0146 20.0589 12.0146C19.2071 12.0146 18.3553 12.0146 17.5036 12.0146C16.8037 12.0146 16.1039 12.0146 15.404 12.0146C14.9682 12.0146 14.5323 12.0146 14.0965 12.0146C14.0118 12.0146 13.9271 12.0146 13.8424 12.0146C13.2447 12.0196 12.7316 12.3783 12.5174 12.9337C12.4153 13.2002 12.4328 13.4866 12.4328 13.768C12.4328 14.1565 12.4328 14.5451 12.4328 14.9311C12.4328 15.5313 12.4328 16.134 12.4328 16.7343C12.4328 17.4939 12.4328 18.251 12.4328 19.0106C12.4328 19.8649 12.4328 20.7217 12.4328 21.5759C12.4328 22.48 12.4328 23.3841 12.4328 24.2882C12.4328 25.1798 12.4328 26.0714 12.4328 26.9655C12.4328 27.7874 12.4328 28.6068 12.4328 29.4287C12.4328 30.1285 12.4328 30.8309 12.4328 31.5307C12.4328 32.0513 12.4328 32.5718 12.4328 33.0923C12.4328 33.3762 12.4328 33.6602 12.4328 33.9441C12.4328 34.0014 12.4303 34.0611 12.4353 34.1184C12.4901 34.8581 13.0803 35.4334 13.83 35.4434C14.0591 35.4459 14.2907 35.4434 14.5199 35.4434C15.0778 35.4434 15.6356 35.4434 16.1935 35.4434C16.9656 35.4434 17.7402 35.4434 18.5122 35.4434C19.4014 35.4434 20.288 35.4434 21.1771 35.4434C22.0688 35.4434 22.9629 35.4434 23.8545 35.4434C24.644 35.4434 25.431 35.4434 26.2205 35.4434C26.7959 35.4434 27.3687 35.4434 27.944 35.4434C28.2005 35.4434 28.4596 35.4459 28.7161 35.4434C29.3313 35.4359 29.8543 35.0549 30.056 34.4771C30.1133 34.3152 30.1233 34.1408 30.1233 33.969C30.1233 33.705 30.1233 33.441 30.1233 33.177C30.1233 32.6714 30.1233 32.1658 30.1233 31.6602C30.1233 30.9703 30.1233 30.2805 30.1233 29.5906C30.1233 28.7737 30.1233 27.9543 30.1233 27.1374C30.1233 26.2532 30.1233 25.3666 30.1233 24.4824C30.1233 23.5783 30.1233 22.6718 30.1233 21.7677C30.1233 20.9035 30.1233 20.0393 30.1233 19.175C30.1233 18.4079 30.1233 17.6408 30.1233 16.8737C30.1233 16.2611 30.1233 15.6509 30.1233 15.0382C30.1233 14.6322 30.1233 14.2263 30.1233 13.8228C30.1233 13.6833 30.1233 13.5439 30.1233 13.4019C30.1233 13.1404 29.8941 12.8913 29.6251 12.9038C29.3512 12.9212 29.1221 13.1279 29.1221 13.4069Z"
              fill="#253B95"
            />
            <rect x="29.4219" y="15" width="5" height="15" fill="#B2E7FF" />
            <path
              d="M33.4364 16.8435C33.4364 17.5484 33.4364 18.2532 33.4364 18.958C33.4364 20.4798 33.4364 22.0015 33.4364 23.5232C33.4364 25.0001 33.4364 26.4745 33.4364 27.9515C33.4364 28.4022 33.4364 28.853 33.4364 29.3038C33.4364 29.4109 33.4364 29.518 33.4364 29.6251C33.4364 29.6425 33.4364 29.66 33.4364 29.6774C33.4364 29.6998 33.4339 29.7247 33.4339 29.7472C33.4314 29.8592 33.4663 29.6401 33.4314 29.7472C33.4214 29.777 33.414 29.8094 33.404 29.8418C33.3741 29.9464 33.4613 29.7496 33.4015 29.8418C33.3841 29.8692 33.3691 29.8966 33.3517 29.924C33.3019 30.0112 33.4115 29.8767 33.3617 29.9115C33.3343 29.9315 33.3069 29.9663 33.2845 29.9912C33.2097 30.0684 33.3766 29.9389 33.2845 29.9912C33.2571 30.0062 33.2272 30.0236 33.2023 30.041C33.1101 30.0983 33.3069 30.0136 33.2023 30.0435C33.1699 30.0535 33.1375 30.061 33.1076 30.0709C33.0005 30.1058 33.2197 30.0709 33.1076 30.0734C33.0802 30.0734 33.0653 30.0759 33.0379 30.0759C33.0329 30.0759 33.0279 30.0759 33.0229 30.0759C32.9507 30.0759 32.876 30.0759 32.8038 30.0759C32.4775 30.0759 32.1488 30.0759 31.8225 30.0759C31.1326 30.0759 30.4427 30.0759 29.7503 30.0759C29.708 30.0759 29.6657 30.0759 29.6208 30.0759C29.7877 30.2428 29.9521 30.4072 30.1189 30.574C30.1189 30.0884 30.1189 29.6052 30.1189 29.1195C30.1189 27.9539 30.1189 26.7908 30.1189 25.6253C30.1189 24.2156 30.1189 22.8084 30.1189 21.3988C30.1189 20.1809 30.1189 18.963 30.1189 17.7451C30.1189 17.1548 30.1414 16.5621 30.1189 15.9718C30.1189 15.9644 30.1189 15.9544 30.1189 15.9469C29.9521 16.1138 29.7877 16.2782 29.6208 16.445C30.7391 16.445 31.8599 16.445 32.9781 16.445C32.998 16.445 33.0155 16.445 33.0354 16.445C33.0678 16.445 33.1076 16.4525 33.14 16.45C33.0205 16.4575 33.0902 16.445 33.1375 16.4575C33.1574 16.4625 33.1799 16.4699 33.1998 16.4774C33.2496 16.4973 33.2396 16.4924 33.1699 16.465C33.1699 16.4625 33.2496 16.5073 33.2546 16.5123C33.272 16.5247 33.2894 16.5347 33.3069 16.5472C33.2496 16.5023 33.2396 16.4948 33.282 16.5297C33.2994 16.5496 33.3193 16.5671 33.3393 16.587C33.4264 16.6692 33.3044 16.5198 33.3517 16.5995C33.3666 16.6268 33.3841 16.6567 33.4015 16.6816C33.4239 16.729 33.4214 16.719 33.3916 16.6518C33.399 16.6717 33.4065 16.6916 33.414 16.714C33.4165 16.7215 33.4389 16.8112 33.4389 16.8112C33.4314 16.7339 33.4289 16.724 33.4339 16.7788C33.4339 16.7987 33.4364 16.8211 33.4364 16.8435C33.4414 17.105 33.663 17.3541 33.9345 17.3416C34.201 17.3292 34.4376 17.1225 34.4326 16.8435C34.4177 16.0764 33.8075 15.4638 33.0379 15.4513C32.8636 15.4488 32.6892 15.4513 32.5124 15.4513C31.7553 15.4513 30.9981 15.4513 30.241 15.4513C30.0343 15.4513 29.8276 15.4513 29.6208 15.4513C29.3519 15.4513 29.1227 15.6804 29.1227 15.9494C29.1227 16.4351 29.1227 16.9182 29.1227 17.4039C29.1227 18.5695 29.1227 19.7326 29.1227 20.8982C29.1227 22.3078 29.1227 23.715 29.1227 25.1247C29.1227 26.3425 29.1227 27.5604 29.1227 28.7783C29.1227 29.3686 29.1103 29.9613 29.1227 30.5516C29.1227 30.5591 29.1227 30.569 29.1227 30.5765C29.1227 30.8455 29.3519 31.0746 29.6208 31.0746C30.1688 31.0746 30.7192 31.0746 31.2671 31.0746C31.8549 31.0746 32.4426 31.0821 33.0304 31.0746C33.7577 31.0647 34.3305 30.5292 34.4202 29.8169C34.4301 29.7272 34.4301 29.6401 34.4301 29.5504C34.4301 29.1918 34.4301 28.8331 34.4301 28.472C34.4301 27.8468 34.4301 27.2217 34.4301 26.5966C34.4301 25.8121 34.4301 25.0275 34.4301 24.243C34.4301 23.4136 34.4301 22.5843 34.4301 21.7574C34.4301 21.0003 34.4301 20.2432 34.4301 19.486C34.4301 18.9057 34.4301 18.3254 34.4301 17.7451C34.4301 17.4587 34.4351 17.1723 34.4301 16.8859C34.4301 16.8734 34.4301 16.861 34.4301 16.8485C34.4301 16.587 34.201 16.3379 33.932 16.3504C33.663 16.3579 33.4364 16.5646 33.4364 16.8435Z"
              fill="#253B95"
            />
            <path
              d="M26.3235 15.9223C26.3235 17.0505 26.3235 18.1762 26.3235 19.3044C26.3235 19.8424 26.3235 20.3829 26.3235 20.9208C26.3235 20.9557 26.321 20.9881 26.3235 21.0229C26.3235 21.0354 26.2911 21.008 26.3235 21.0578C26.326 21.0354 26.3285 21.0155 26.331 20.993C26.326 21.0155 26.321 21.0354 26.3135 21.0578C26.3335 21.0578 26.3385 20.9407 26.321 21.0279C26.316 21.0379 26.3086 21.0453 26.3036 21.0553C26.3484 20.998 26.3534 20.9881 26.3185 21.0279C26.336 21.0155 26.3534 21.003 26.3683 20.9906C26.3509 21.003 26.331 21.0155 26.3135 21.0254C26.3335 21.0179 26.3534 21.0105 26.3733 21.003C26.3534 21.0105 26.331 21.0179 26.3086 21.0204C26.3011 21.0005 26.4406 21.0179 26.3385 21.013C26.2737 21.0105 26.2065 21.013 26.1417 21.013C25.0732 21.013 24.0023 21.013 22.9338 21.013C21.4295 21.013 19.9252 21.013 18.4209 21.013C17.8631 21.013 17.3052 21.013 16.7473 21.013C16.5107 21.013 16.2716 21.003 16.035 21.013H16.0325C15.9154 21.0179 16.1421 21.0379 16.03 21.013C15.9179 20.9881 16.1296 21.0603 16.03 21.0105C15.9354 20.9656 16.0873 21.0628 16.0425 21.0179C15.9976 20.9731 16.0948 21.125 16.0499 21.0304C16.0001 20.9283 16.0723 21.14 16.0474 21.0304C16.0225 20.9183 16.0425 21.145 16.0474 21.0279C16.0474 20.998 16.0474 20.9681 16.0474 20.9407C16.0474 20.7415 16.0474 20.5398 16.0474 20.3405C16.0474 19.6282 16.0474 18.9159 16.0474 18.2061C16.0474 17.561 16.0474 16.9185 16.0474 16.2734C16.0474 16.1589 16.0524 16.0418 16.0474 15.9272C16.0474 15.9148 16.0773 15.9372 16.0474 15.8924C16.0449 15.9148 16.0425 15.9347 16.04 15.9571C16.0449 15.9347 16.0499 15.9148 16.0574 15.8924C16.0499 15.9123 16.0425 15.9322 16.035 15.9521C16.0449 15.9322 16.0574 15.9148 16.0698 15.8973C16.0574 15.9148 16.0449 15.9322 16.0325 15.9472C16.0723 15.9098 16.0624 15.9148 16.0051 15.9621C16.0151 15.9571 16.0225 15.9496 16.0325 15.9447C16.0698 15.9247 16.0698 15.9223 16.0325 15.9397C16.0225 15.9447 16.0126 15.9472 16.0026 15.9521C16.0225 15.9447 16.0449 15.9372 16.0674 15.9347C16.0723 15.9521 15.9378 15.9372 16.04 15.9422C16.0599 15.9422 16.0798 15.9422 16.0997 15.9422C17.0362 15.9422 17.9751 15.9422 18.9116 15.9422C20.4234 15.9422 21.9376 15.9422 23.4494 15.9422C24.3933 15.9422 25.3372 15.9422 26.2812 15.9422C26.3011 15.9422 26.3235 15.9422 26.3434 15.9422H26.3459C26.4281 15.9397 26.3111 15.9521 26.316 15.9347C26.326 15.9372 26.3385 15.9397 26.3484 15.9422C26.4007 15.9596 26.3908 15.9546 26.321 15.9297C26.331 15.9347 26.3409 15.9397 26.3484 15.9472C26.3932 15.977 26.3858 15.9721 26.326 15.9272C26.4057 15.992 26.2862 15.8351 26.331 15.9272C26.3683 16.0219 26.2961 15.8102 26.3235 15.9223C26.321 15.8027 26.3484 16.0343 26.3235 15.9223C26.3335 16.1813 26.5452 16.4328 26.8216 16.4204C27.0831 16.4079 27.3297 16.2012 27.3197 15.9223C27.2998 15.3594 26.864 14.941 26.3036 14.9385C26.199 14.9385 26.0944 14.9385 25.9923 14.9385C25.5141 14.9385 25.0359 14.9385 24.5602 14.9385C23.0509 14.9385 21.5441 14.9385 20.0348 14.9385C18.8269 14.9385 17.6165 14.9385 16.4086 14.9385C16.2965 14.9385 16.1844 14.9385 16.0723 14.9385C15.6116 14.941 15.1857 15.2249 15.0761 15.6881C15.0363 15.855 15.0487 16.0343 15.0487 16.2062C15.0487 16.4776 15.0487 16.7466 15.0487 17.0181C15.0487 18.3281 15.0487 19.6357 15.0487 20.9457C15.0487 20.9831 15.0487 21.0229 15.0487 21.0628C15.0711 21.4961 15.37 21.8822 15.7984 21.9843C15.9279 22.0142 16.0524 22.0117 16.1819 22.0117C16.5829 22.0117 16.9864 22.0117 17.3874 22.0117C18.8418 22.0117 20.2938 22.0117 21.7483 22.0117C23.0634 22.0117 24.3784 22.0117 25.6934 22.0117C25.92 22.0117 26.1517 22.0216 26.3783 22.0117C26.9462 21.9818 27.3272 21.5186 27.3272 20.9656C27.3272 20.7689 27.3272 20.5721 27.3272 20.3729C27.3272 18.9956 27.3272 17.6208 27.3272 16.2435C27.3272 16.1364 27.3272 16.0293 27.3272 15.9223C27.3272 15.6607 27.0981 15.4117 26.8291 15.4241C26.5526 15.4366 26.3235 15.6433 26.3235 15.9223Z"
              fill="#253B95"
            />
            <path
              d="M17.5526 24.2305C17.052 24.2305 16.5539 24.2305 16.0532 24.2305C15.7917 24.2305 15.5427 24.4596 15.5551 24.7286C15.5676 24.9976 15.7743 25.2267 16.0532 25.2267C16.5539 25.2267 17.052 25.2267 17.5526 25.2267C17.8141 25.2267 18.0631 24.9976 18.0507 24.7286C18.0382 24.4596 17.8315 24.2305 17.5526 24.2305Z"
              fill="#253B95"
            />
            <path
              d="M25.9959 24.2305C25.4953 24.2305 24.9972 24.2305 24.4966 24.2305C24.2351 24.2305 23.986 24.4596 23.9985 24.7286C24.0109 24.9976 24.2177 25.2267 24.4966 25.2267C24.9972 25.2267 25.4953 25.2267 25.9959 25.2267C26.2574 25.2267 26.5065 24.9976 26.494 24.7286C26.4816 24.4596 26.2749 24.2305 25.9959 24.2305Z"
              fill="#253B95"
            />
            <path
              d="M17.5838 31.207C17.0832 31.207 16.5851 31.207 16.0845 31.207C15.823 31.207 15.5739 31.4362 15.5864 31.7051C15.5988 31.9741 15.8056 32.2033 16.0845 32.2033C16.5851 32.2033 17.0832 32.2033 17.5838 32.2033C17.8453 32.2033 18.0944 31.9741 18.0819 31.7051C18.0695 31.4337 17.8628 31.207 17.5838 31.207Z"
              fill="#253B95"
            />
            <path
              d="M26.0272 31.207C25.5266 31.207 25.0285 31.207 24.5279 31.207C24.2663 31.207 24.0173 31.4362 24.0297 31.7051C24.0422 31.9741 24.2489 32.2033 24.5279 32.2033C25.0285 32.2033 25.5266 32.2033 26.0272 32.2033C26.2887 32.2033 26.5377 31.9741 26.5253 31.7051C26.5153 31.4337 26.3086 31.207 26.0272 31.207Z"
              fill="#253B95"
            />
          </svg>
          <p class="tiny text-center mt-1 text-gray-700">Pos</p>
        </router-link>
      </div>
      <div class="mt-6">
        <router-link
          class="flex items-center flex-col"
          :to="{ name: 'SalesHistory' }"
        >
          <svg
            class="-ml-1"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 3.75C0 1.67893 1.67893 0 3.75 0H26.25C28.3211 0 30 1.67893 30 3.75V26.25C30 28.3211 28.3211 30 26.25 30H3.75C1.67893 30 0 28.3211 0 26.25V3.75Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.30273 20.28L23.4902 20.1562L22.0577 22.0262H7.60687L6.30273 20.28Z"
              fill="#B2E7FF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.8585 19.8125C23.8035 19.7575 23.721 19.7025 23.6385 19.7025H22.8135V8.51C22.8135 8.345 22.7035 8.235 22.5385 8.235H7.68848C7.52348 8.235 7.41348 8.345 7.41348 8.51V19.73H6.58848C6.50598 19.73 6.42348 19.7575 6.36848 19.84C6.31348 19.895 6.31348 19.9775 6.31348 20.06C6.61598 21.4625 7.55098 22.315 8.81598 22.315H21.411C22.676 22.315 23.611 21.435 23.9135 20.06C23.9135 19.9775 23.9135 19.895 23.8585 19.8125ZM7.96362 8.785H22.2636V19.73H7.96362V8.785ZM8.81617 21.765H21.4112C22.2912 21.765 22.9787 21.215 23.2812 20.28H6.94617C7.24867 21.215 7.93617 21.765 8.81617 21.765Z"
              fill="#253B95"
            />
            <path
              d="M15.8002 20.7475H14.4527C14.2877 20.7475 14.1777 20.8575 14.1777 21.0225C14.1777 21.1875 14.2877 21.2975 14.4527 21.2975H15.8002C15.9652 21.2975 16.0752 21.1875 16.0752 21.0225C16.0752 20.8575 15.9377 20.7475 15.8002 20.7475Z"
              fill="#253B95"
            />
            <path
              d="M20.2553 11.0675H18.3578C18.1928 11.0675 18.0828 11.1775 18.0828 11.3425C18.0828 11.5075 18.1928 11.6175 18.3578 11.6175H19.5953L15.4978 15.715L13.4628 13.68C13.3528 13.57 13.1878 13.57 13.0778 13.68L9.77781 16.9525C9.66781 17.0625 9.66781 17.2275 9.77781 17.3375C9.83281 17.3925 9.91531 17.42 9.97031 17.42C10.0528 17.42 10.1078 17.3925 10.1628 17.3375L13.2428 14.2575L15.2778 16.2925C15.3878 16.4025 15.5528 16.4025 15.6628 16.2925L19.9528 12.0025V13.24C19.9528 13.405 20.0628 13.515 20.2278 13.515C20.3928 13.515 20.5028 13.405 20.5028 13.24V11.3425C20.5303 11.1775 20.4203 11.0675 20.2553 11.0675Z"
              fill="#253B95"
            />
          </svg>
          <p class="tiny text-center mt-1 text-gray-700">
            Sales <br />
            History
          </p>
        </router-link>
      </div>
      <div class="mt-6">
        <router-link
          class="flex items-center flex-col"
          :to="{ name: 'Orders' }"
        >
          <svg
            width="30"
            class="-ml-1"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 3.47108C0 1.55405 1.55405 0 3.47107 0H26.5289C28.4459 0 30 1.55405 30 3.47107V26.5289C30 28.4459 28.4459 30 26.5289 30H3.47108C1.55405 30 0 28.4459 0 26.5289V3.47108Z"
              fill="#EFFAFF"
            />
            <ellipse
              cx="13.125"
              cy="21.25"
              rx="0.625"
              ry="0.624999"
              fill="#B2E7FF"
              stroke="#253B95"
              stroke-width="0.578512"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <ellipse
              cx="20"
              cy="21.25"
              rx="0.625001"
              ry="0.624999"
              fill="#B2E7FF"
              stroke="#253B95"
              stroke-width="0.578512"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.125 8.75H10.625L12.3 17.1187C12.418 17.7126 12.9446 18.1366 13.55 18.125H19.625C20.2304 18.1366 20.757 17.7126 20.875 17.1187L21.875 11.875H11.25"
              stroke="#253B95"
              stroke-width="0.578512"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p class="tiny text-center mt-1 text-gray-700">Orders</p>
        </router-link>
      </div>
      <div class="mt-6" v-if="authRole === 'admin'">
          <!-- to="/login" -->
        <div
          class="flex items-center flex-col cursor-pointer"
          @click="$router.push({ name: 'Kyc' })"
        >
        <!-- ../../assets/svg/routes/${name}/${pic} -->
        <img src="../../assets/svg/routes/profile/manageUsers.svg" alt="" class="">
          <!-- <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 34 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6C0 2.68629 2.68629 0 6 0H27.4365C30.7502 0 33.4365 2.68629 33.4365 6V24C33.4365 27.3137 30.7502 30 27.4365 30H6C2.68629 30 0 27.3137 0 24V6Z"
              fill="#EFFAFF"
            />
            <path
              d="M14.4888 23H10.7736C9.74768 23 8.91602 22.2538 8.91602 21.3333V9.66667C8.91602 8.74619 9.74768 8 10.7736 8H14.4888"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.9902 19.6667L25.6342 15.5001L20.9902 11.3335"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.6338 15.5001H14.4883"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg> -->
          <p class="tiny text-center mt-1 text-gray-700">KYC</p>
        </div>
      </div>
    </div>
    <div
      class="relative"
      :class="active ? 'hidden md:block' : 'block md:hidden'"
    >
      <div class="mt-8 tiny flex items-center">
        <div class="whitespace-no-wrap">FREQUENTLY USED</div>
        <svg
          class="w-4 ml-4 cursor-pointer h-4"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.94118 2.87175H2.76471C1.79009 2.87175 1 3.66184 1 4.63646V16.9894C1 17.964 1.79009 18.7541 2.76471 18.7541H15.1176C16.0923 18.7541 16.8824 17.964 16.8824 16.9894V10.8129"
            stroke="#013E9E"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.5587 1.54822C16.2896 0.817259 17.4747 0.817259 18.2057 1.54822C18.9367 2.27919 18.9367 3.46432 18.2057 4.19528L9.82336 12.5776L6.29395 13.46L7.1763 9.93058L15.5587 1.54822Z"
            stroke="#013E9E"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="mt-6 grid grid-cols-3 row-gap-5">
        <div>
          <router-link
            class="flex justify-center items-center flex-col"
            to="/dashboard"
          >
            <svg
              class="w-6 h-6"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 6C0 2.68629 2.68629 0 6 0H24C27.3137 0 30 2.68629 30 6V24C30 27.3137 27.3137 30 24 30H6C2.68629 30 0 27.3137 0 24V6Z"
                fill="#EFFAFF"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 13.25L14.75 8L21.5 13.25V21.5C21.5 22.3284 20.8284 23 20 23H9.5C8.67157 23 8 22.3284 8 21.5V13.25Z"
                stroke="#253B95"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 23V15.5H17V23"
                stroke="#253B95"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="tiny pt-2 text-primaryGray">Home</div>
          </router-link>
        </div>
        <div v-for="(frequent, i) in frequently" :key="i">
          <router-link
            class="flex justify-center items-center w-full flex-col"
            :to="{ name: frequent.routeName }"
          >
            <div class="w-6 h-6 rounded">
              <!--  :src="`@/assets/svg/${frequent.icon}`" -->
              <img class="w-full h-full" :src="getImg(frequent.icon)" alt="" />
            </div>
            <div class="tiny pt-2 text-primaryGray">{{ frequent.name }}</div>
            <!-- <div class="tiny pl-1 pt-2">Add</div> -->
          </router-link>
        </div>
        <div class="">
          <!-- to="/login" -->
        <div
          class="flex items-center flex-col cursor-pointer"
          @click="logUserOut"
        >
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 34 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6C0 2.68629 2.68629 0 6 0H27.4365C30.7502 0 33.4365 2.68629 33.4365 6V24C33.4365 27.3137 30.7502 30 27.4365 30H6C2.68629 30 0 27.3137 0 24V6Z"
              fill="#EFFAFF"
            />
            <path
              d="M14.4888 23H10.7736C9.74768 23 8.91602 22.2538 8.91602 21.3333V9.66667C8.91602 8.74619 9.74768 8 10.7736 8H14.4888"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.9902 19.6667L25.6342 15.5001L20.9902 11.3335"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.6338 15.5001H14.4883"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p class="tiny text-center mt-1 text-gray-700">Logout</p>
        </div>
      </div>
      </div>

      <div class="mt-6">
        <div class="flex items-center">
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6.24237C0 2.92866 2.68629 0.242371 6 0.242371H24C27.3137 0.242371 30 2.92866 30 6.24237V24.2424C30 27.5561 27.3137 30.2424 24 30.2424H6C2.68629 30.2424 0 27.5561 0 24.2424V6.24237Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8694 7.35107C9.83777 7.37018 9.00002 8.19014 9.00002 9.22582V21.8377C8.99915 21.8992 9.03144 21.9564 9.08453 21.9874C9.12018 22.0082 9.1615 22.015 9.20088 22.0079C9.20518 22.0081 9.2095 22.0082 9.21385 22.0082H18.3737C18.4679 22.0082 18.5442 21.9319 18.5442 21.8377V15.1909H21.7824C21.8765 15.1909 21.9528 15.1146 21.9528 15.0205V9.22582C21.9528 8.19016 21.1137 7.35107 20.0781 7.35107H10.8748H10.8694ZM18.2033 21.6673H9.34088V9.22582C9.34088 8.37493 10.0209 7.71051 10.8748 7.69194H10.8801H18.9969C18.5173 8.03265 18.2033 8.59288 18.2033 9.22582V21.6673ZM21.6119 9.22582V14.8501H18.5442V9.22582C18.5442 8.43948 19.1234 7.79798 19.881 7.70259C19.8974 7.70135 19.9135 7.69777 19.9289 7.69194H20.0781C20.9308 7.69194 21.6119 8.3731 21.6119 9.22582ZM10.8428 16.7248C10.7487 16.7336 10.6795 16.8171 10.6884 16.9112C10.6972 17.0053 10.7806 17.0745 10.8748 17.0657H16.6694C16.7309 17.0665 16.7881 17.0342 16.8191 16.9812C16.85 16.9281 16.85 16.8624 16.8191 16.8093C16.7881 16.7562 16.7309 16.7239 16.6694 16.7248H10.8748C10.8641 16.7238 10.8534 16.7238 10.8428 16.7248ZM10.6884 19.2973C10.6795 19.2031 10.7487 19.1197 10.8428 19.1108C10.8534 19.1098 10.8641 19.1098 10.8748 19.1108H13.2608C13.3223 19.11 13.3794 19.1423 13.4104 19.1954C13.4414 19.2484 13.4414 19.3141 13.4104 19.3672C13.3794 19.4203 13.3223 19.4526 13.2608 19.4517H10.8748C10.7806 19.4605 10.6972 19.3914 10.6884 19.2973Z"
              fill="#253B95"
            />
            <path
              d="M10.8694 7.35107V7.09853L10.8648 7.09862L10.8694 7.35107ZM9.00002 21.8377L9.25252 21.8413V21.8377H9.00002ZM9.08453 21.9874L8.95725 22.2054L8.95725 22.2054L9.08453 21.9874ZM9.20088 22.0079L9.21647 21.7558L9.18594 21.754L9.15584 21.7594L9.20088 22.0079ZM9.21385 22.0082V21.7557L9.21031 21.7557L9.21385 22.0082ZM18.3737 22.0082V22.2607H18.3738L18.3737 22.0082ZM18.5442 21.8377L18.7967 21.8378V21.8377H18.5442ZM18.5442 15.1909V14.9384H18.2917V15.1909H18.5442ZM21.7824 15.1909V15.4434H21.7824L21.7824 15.1909ZM21.9528 15.0205L22.2053 15.0205V15.0205H21.9528ZM9.34088 21.6673H9.08838V21.9198H9.34088V21.6673ZM18.2033 21.6673V21.9198H18.4558V21.6673H18.2033ZM10.8748 7.69194V7.43938L10.8693 7.4395L10.8748 7.69194ZM18.9969 7.69194L19.1431 7.89779L19.7883 7.43944H18.9969V7.69194ZM21.6119 14.8501V15.1026H21.8644V14.8501H21.6119ZM18.5442 14.8501H18.2917V15.1026H18.5442V14.8501ZM19.881 7.70259L19.862 7.45049L19.8495 7.45207L19.881 7.70259ZM19.9289 7.69194V7.43944H19.8827L19.8395 7.45581L19.9289 7.69194ZM10.8428 16.7248L10.8664 16.9762L10.8665 16.9762L10.8428 16.7248ZM10.8748 17.0657V16.8132H10.863L10.8512 16.8143L10.8748 17.0657ZM16.6694 17.0657L16.673 16.8132H16.6694V17.0657ZM16.8191 16.9812L17.0371 17.1084L17.0371 17.1084L16.8191 16.9812ZM16.8191 16.8093L17.0371 16.682L17.0371 16.682L16.8191 16.8093ZM16.6694 16.7248V16.9773L16.673 16.9773L16.6694 16.7248ZM10.8748 16.7248L10.8511 16.9762L10.8629 16.9773H10.8748V16.7248ZM10.8428 19.1108L10.8664 19.3622L10.8665 19.3622L10.8428 19.1108ZM10.8748 19.1108L10.8511 19.3622L10.8629 19.3633H10.8748V19.1108ZM13.2608 19.1108V19.3634L13.2644 19.3633L13.2608 19.1108ZM13.4104 19.1954L13.1923 19.3226L13.1923 19.3226L13.4104 19.1954ZM13.4104 19.3672L13.6285 19.4945V19.4945L13.4104 19.3672ZM13.2608 19.4517L13.2644 19.1992H13.2608V19.4517ZM10.8748 19.4517V19.1992H10.863L10.8512 19.2003L10.8748 19.4517ZM9.25252 9.22582C9.25252 8.33319 9.97456 7.62019 10.8741 7.60353L10.8648 7.09862C9.70097 7.12017 8.74752 8.04709 8.74752 9.22582H9.25252ZM9.25252 21.8377V9.22582H8.74752V21.8377H9.25252ZM9.21181 21.7693C9.23736 21.7842 9.25291 21.8117 9.25249 21.8413L8.74754 21.8342C8.74539 21.9867 8.82552 22.1286 8.95725 22.2054L9.21181 21.7693ZM9.15584 21.7594C9.17469 21.756 9.19461 21.7593 9.21181 21.7693L8.95725 22.2054C9.04575 22.2571 9.14831 22.274 9.24592 22.2563L9.15584 21.7594ZM9.21031 21.7557C9.21237 21.7557 9.21443 21.7557 9.21647 21.7558L9.18528 22.2599C9.19592 22.2605 9.20664 22.2608 9.2174 22.2607L9.21031 21.7557ZM18.3737 21.7557H9.21385V22.2607H18.3737V21.7557ZM18.2917 21.8377C18.2917 21.7924 18.3284 21.7557 18.3737 21.7557L18.3738 22.2607C18.6073 22.2607 18.7967 22.0713 18.7967 21.8378L18.2917 21.8377ZM18.2917 15.1909V21.8377H18.7967V15.1909H18.2917ZM21.7824 14.9384H18.5442V15.4434H21.7824V14.9384ZM21.7003 15.0205C21.7003 14.9752 21.737 14.9384 21.7823 14.9384L21.7824 15.4434C22.016 15.4434 22.2053 15.2541 22.2053 15.0205L21.7003 15.0205ZM21.7003 9.22582V15.0205H22.2053V9.22582H21.7003ZM20.0781 7.60357C20.9743 7.60357 21.7003 8.32961 21.7003 9.22582H22.2053C22.2053 8.05071 21.2532 7.09857 20.0781 7.09857V7.60357ZM10.8748 7.60357H20.0781V7.09857H10.8748V7.60357ZM10.8694 7.60357H10.8748V7.09857H10.8694V7.60357ZM9.34088 21.9198H18.2033V21.4148H9.34088V21.9198ZM9.08838 9.22582V21.6673H9.59338V9.22582H9.08838ZM10.8693 7.4395C9.88501 7.46091 9.08838 8.23088 9.08838 9.22582H9.59338C9.59338 8.51899 10.1569 7.96011 10.8803 7.94438L10.8693 7.4395ZM10.8801 7.43944H10.8748V7.94444H10.8801V7.43944ZM18.9969 7.43944H10.8801V7.94444H18.9969V7.43944ZM18.4558 9.22582C18.4558 8.67837 18.7271 8.19333 19.1431 7.89779L18.8507 7.48609C18.3074 7.87197 17.9508 8.50738 17.9508 9.22582H18.4558ZM18.4558 21.6673V9.22582H17.9508V21.6673H18.4558ZM21.8644 14.8501V9.22582H21.3594V14.8501H21.8644ZM18.5442 15.1026H21.6119V14.5976H18.5442V15.1026ZM18.2917 9.22582V14.8501H18.7967V9.22582H18.2917ZM19.8495 7.45207C18.9664 7.56326 18.2917 8.31143 18.2917 9.22582H18.7967C18.7967 8.56753 19.2804 8.0327 19.9125 7.95311L19.8495 7.45207ZM19.8395 7.45581C19.8467 7.45307 19.8543 7.45138 19.862 7.4508L19.9 7.95437C19.9405 7.95132 19.9804 7.94246 20.0184 7.92806L19.8395 7.45581ZM20.0781 7.43944H19.9289V7.94444H20.0781V7.43944ZM21.8644 9.22582C21.8644 8.23365 21.0702 7.43944 20.0781 7.43944V7.94444C20.7913 7.94444 21.3594 8.51255 21.3594 9.22582H21.8644ZM10.9398 16.8876C10.9439 16.9324 10.9111 16.972 10.8664 16.9762L10.8192 16.4734C10.5863 16.4952 10.4151 16.7018 10.437 16.9348L10.9398 16.8876ZM10.8512 16.8143C10.8959 16.8101 10.9356 16.8429 10.9398 16.8876L10.437 16.9348C10.4588 17.1677 10.6654 17.3389 10.8983 17.3171L10.8512 16.8143ZM16.6694 16.8132H10.8748V17.3182H16.6694V16.8132ZM16.601 16.8539C16.6159 16.8283 16.6434 16.8128 16.673 16.8132L16.6659 17.3181C16.8184 17.3203 16.9602 17.2402 17.0371 17.1084L16.601 16.8539ZM16.601 16.9366C16.5861 16.911 16.5861 16.8794 16.601 16.8539L17.0371 17.1084C17.114 16.9767 17.114 16.8138 17.0371 16.682L16.601 16.9366ZM16.673 16.9773C16.6434 16.9777 16.6159 16.9622 16.601 16.9366L17.0371 16.682C16.9602 16.5503 16.8184 16.4702 16.6659 16.4723L16.673 16.9773ZM10.8748 16.9773H16.6694V16.4723H10.8748V16.9773ZM10.8665 16.9762C10.8614 16.9767 10.8562 16.9767 10.8511 16.9762L10.8984 16.4734C10.8721 16.4709 10.8455 16.4709 10.8191 16.4734L10.8665 16.9762ZM10.8192 18.8594C10.5863 18.8813 10.4151 19.0879 10.437 19.3208L10.9398 19.2737C10.9439 19.3184 10.9111 19.358 10.8664 19.3622L10.8192 18.8594ZM10.8984 18.8595C10.8721 18.857 10.8455 18.857 10.8191 18.8595L10.8665 19.3622C10.8614 19.3627 10.8562 19.3627 10.8511 19.3622L10.8984 18.8595ZM13.2608 18.8583H10.8748V19.3633H13.2608V18.8583ZM13.6285 19.0681C13.5516 18.9363 13.4097 18.8562 13.2572 18.8584L13.2644 19.3633C13.2348 19.3637 13.2073 19.3482 13.1923 19.3226L13.6285 19.0681ZM13.6285 19.4945C13.7054 19.3627 13.7054 19.1998 13.6285 19.0681L13.1923 19.3226C13.1774 19.2971 13.1774 19.2655 13.1923 19.2399L13.6285 19.4945ZM13.2572 19.7042C13.4097 19.7063 13.5516 19.6262 13.6285 19.4945L13.1923 19.2399C13.2073 19.2144 13.2348 19.1988 13.2644 19.1992L13.2572 19.7042ZM10.8748 19.7042H13.2608V19.1992H10.8748V19.7042ZM10.437 19.3208C10.4588 19.5538 10.6654 19.7249 10.8983 19.7031L10.8512 19.2003C10.8959 19.1961 10.9356 19.229 10.9398 19.2737L10.437 19.3208Z"
              fill="#253B95"
            />
            <path
              d="M12.8838 14.2705V11.5763C12.8838 11.3627 13.1695 11.2913 13.2699 11.4798L14.5746 13.9276C14.675 14.1161 14.9607 14.0454 14.9607 13.8319C14.9607 13.0517 14.9607 11.8702 14.9607 10.9914"
              stroke="#253B95"
              stroke-width="0.4"
            />
            <rect x="12" y="13.0954" width="4" height="0.4" fill="#253B95" />
            <rect x="12" y="12.1723" width="4" height="0.4" fill="#253B95" />
          </svg>
          <div
            class="
              ml-3
              tracking-wide
              uppercase
              tiny
              font-medium
              text-accentDark
            "
          >
            <p class="whitespace-no-wrap">Business Services</p>
          </div>
          <svg
            @click="businessServicesToggle = !businessServicesToggle"
            class="w-3 h-3 ml-2 cursor-pointer"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7L13 1"
              stroke="#253B95"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div
          v-if="businessServicesToggle"
          class="mt-6 grid grid-cols-3 row-gap-8 items-start justify-start"
        >
          <div
            class="increase-spacing-nav"
            v-for="(business, i) in businessServices"
            :key="i"
          >
            <router-link
              class="flex justify-center items-center flex-col"
              :to="{ name: `${business.routeName || 'Dashboard'}` }"
            >
              <div class="w-6 h-6 rounded">
                <img
                  class="w-full h-full"
                  :src="getImgUrl(business.icon, 'businessServices')"
                  alt=""
                />
              </div>
              <div
                class="
                  very-tiny
                  text-primaryGray
                  uppercase
                  text-center
                  items-center
                  pl-1
                  pt-2
                "
              >
                {{ business.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="mt-6">
        <div class="flex items-center">
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6.24237C0 2.92866 2.68629 0.242371 6 0.242371H24C27.3137 0.242371 30 2.92866 30 6.24237V24.2424C30 27.5561 27.3137 30.2424 24 30.2424H6C2.68629 30.2424 0 27.5561 0 24.2424V6.24237Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8694 7.35107C9.83777 7.37018 9.00002 8.19014 9.00002 9.22582V21.8377C8.99915 21.8992 9.03144 21.9564 9.08453 21.9874C9.12018 22.0082 9.1615 22.015 9.20088 22.0079C9.20518 22.0081 9.2095 22.0082 9.21385 22.0082H18.3737C18.4679 22.0082 18.5442 21.9319 18.5442 21.8377V15.1909H21.7824C21.8765 15.1909 21.9528 15.1146 21.9528 15.0205V9.22582C21.9528 8.19016 21.1137 7.35107 20.0781 7.35107H10.8748H10.8694ZM18.2033 21.6673H9.34088V9.22582C9.34088 8.37493 10.0209 7.71051 10.8748 7.69194H10.8801H18.9969C18.5173 8.03265 18.2033 8.59288 18.2033 9.22582V21.6673ZM21.6119 9.22582V14.8501H18.5442V9.22582C18.5442 8.43948 19.1234 7.79798 19.881 7.70259C19.8974 7.70135 19.9135 7.69777 19.9289 7.69194H20.0781C20.9308 7.69194 21.6119 8.3731 21.6119 9.22582ZM10.8428 16.7248C10.7487 16.7336 10.6795 16.8171 10.6884 16.9112C10.6972 17.0053 10.7806 17.0745 10.8748 17.0657H16.6694C16.7309 17.0665 16.7881 17.0342 16.8191 16.9812C16.85 16.9281 16.85 16.8624 16.8191 16.8093C16.7881 16.7562 16.7309 16.7239 16.6694 16.7248H10.8748C10.8641 16.7238 10.8534 16.7238 10.8428 16.7248ZM10.6884 19.2973C10.6795 19.2031 10.7487 19.1197 10.8428 19.1108C10.8534 19.1098 10.8641 19.1098 10.8748 19.1108H13.2608C13.3223 19.11 13.3794 19.1423 13.4104 19.1954C13.4414 19.2484 13.4414 19.3141 13.4104 19.3672C13.3794 19.4203 13.3223 19.4526 13.2608 19.4517H10.8748C10.7806 19.4605 10.6972 19.3914 10.6884 19.2973Z"
              fill="#253B95"
            />
            <path
              d="M10.8694 7.35107V7.09853L10.8648 7.09862L10.8694 7.35107ZM9.00002 21.8377L9.25252 21.8413V21.8377H9.00002ZM9.08453 21.9874L8.95725 22.2054L8.95725 22.2054L9.08453 21.9874ZM9.20088 22.0079L9.21647 21.7558L9.18594 21.754L9.15584 21.7594L9.20088 22.0079ZM9.21385 22.0082V21.7557L9.21031 21.7557L9.21385 22.0082ZM18.3737 22.0082V22.2607H18.3738L18.3737 22.0082ZM18.5442 21.8377L18.7967 21.8378V21.8377H18.5442ZM18.5442 15.1909V14.9384H18.2917V15.1909H18.5442ZM21.7824 15.1909V15.4434H21.7824L21.7824 15.1909ZM21.9528 15.0205L22.2053 15.0205V15.0205H21.9528ZM9.34088 21.6673H9.08838V21.9198H9.34088V21.6673ZM18.2033 21.6673V21.9198H18.4558V21.6673H18.2033ZM10.8748 7.69194V7.43938L10.8693 7.4395L10.8748 7.69194ZM18.9969 7.69194L19.1431 7.89779L19.7883 7.43944H18.9969V7.69194ZM21.6119 14.8501V15.1026H21.8644V14.8501H21.6119ZM18.5442 14.8501H18.2917V15.1026H18.5442V14.8501ZM19.881 7.70259L19.862 7.45049L19.8495 7.45207L19.881 7.70259ZM19.9289 7.69194V7.43944H19.8827L19.8395 7.45581L19.9289 7.69194ZM10.8428 16.7248L10.8664 16.9762L10.8665 16.9762L10.8428 16.7248ZM10.8748 17.0657V16.8132H10.863L10.8512 16.8143L10.8748 17.0657ZM16.6694 17.0657L16.673 16.8132H16.6694V17.0657ZM16.8191 16.9812L17.0371 17.1084L17.0371 17.1084L16.8191 16.9812ZM16.8191 16.8093L17.0371 16.682L17.0371 16.682L16.8191 16.8093ZM16.6694 16.7248V16.9773L16.673 16.9773L16.6694 16.7248ZM10.8748 16.7248L10.8511 16.9762L10.8629 16.9773H10.8748V16.7248ZM10.8428 19.1108L10.8664 19.3622L10.8665 19.3622L10.8428 19.1108ZM10.8748 19.1108L10.8511 19.3622L10.8629 19.3633H10.8748V19.1108ZM13.2608 19.1108V19.3634L13.2644 19.3633L13.2608 19.1108ZM13.4104 19.1954L13.1923 19.3226L13.1923 19.3226L13.4104 19.1954ZM13.4104 19.3672L13.6285 19.4945V19.4945L13.4104 19.3672ZM13.2608 19.4517L13.2644 19.1992H13.2608V19.4517ZM10.8748 19.4517V19.1992H10.863L10.8512 19.2003L10.8748 19.4517ZM9.25252 9.22582C9.25252 8.33319 9.97456 7.62019 10.8741 7.60353L10.8648 7.09862C9.70097 7.12017 8.74752 8.04709 8.74752 9.22582H9.25252ZM9.25252 21.8377V9.22582H8.74752V21.8377H9.25252ZM9.21181 21.7693C9.23736 21.7842 9.25291 21.8117 9.25249 21.8413L8.74754 21.8342C8.74539 21.9867 8.82552 22.1286 8.95725 22.2054L9.21181 21.7693ZM9.15584 21.7594C9.17469 21.756 9.19461 21.7593 9.21181 21.7693L8.95725 22.2054C9.04575 22.2571 9.14831 22.274 9.24592 22.2563L9.15584 21.7594ZM9.21031 21.7557C9.21237 21.7557 9.21443 21.7557 9.21647 21.7558L9.18528 22.2599C9.19592 22.2605 9.20664 22.2608 9.2174 22.2607L9.21031 21.7557ZM18.3737 21.7557H9.21385V22.2607H18.3737V21.7557ZM18.2917 21.8377C18.2917 21.7924 18.3284 21.7557 18.3737 21.7557L18.3738 22.2607C18.6073 22.2607 18.7967 22.0713 18.7967 21.8378L18.2917 21.8377ZM18.2917 15.1909V21.8377H18.7967V15.1909H18.2917ZM21.7824 14.9384H18.5442V15.4434H21.7824V14.9384ZM21.7003 15.0205C21.7003 14.9752 21.737 14.9384 21.7823 14.9384L21.7824 15.4434C22.016 15.4434 22.2053 15.2541 22.2053 15.0205L21.7003 15.0205ZM21.7003 9.22582V15.0205H22.2053V9.22582H21.7003ZM20.0781 7.60357C20.9743 7.60357 21.7003 8.32961 21.7003 9.22582H22.2053C22.2053 8.05071 21.2532 7.09857 20.0781 7.09857V7.60357ZM10.8748 7.60357H20.0781V7.09857H10.8748V7.60357ZM10.8694 7.60357H10.8748V7.09857H10.8694V7.60357ZM9.34088 21.9198H18.2033V21.4148H9.34088V21.9198ZM9.08838 9.22582V21.6673H9.59338V9.22582H9.08838ZM10.8693 7.4395C9.88501 7.46091 9.08838 8.23088 9.08838 9.22582H9.59338C9.59338 8.51899 10.1569 7.96011 10.8803 7.94438L10.8693 7.4395ZM10.8801 7.43944H10.8748V7.94444H10.8801V7.43944ZM18.9969 7.43944H10.8801V7.94444H18.9969V7.43944ZM18.4558 9.22582C18.4558 8.67837 18.7271 8.19333 19.1431 7.89779L18.8507 7.48609C18.3074 7.87197 17.9508 8.50738 17.9508 9.22582H18.4558ZM18.4558 21.6673V9.22582H17.9508V21.6673H18.4558ZM21.8644 14.8501V9.22582H21.3594V14.8501H21.8644ZM18.5442 15.1026H21.6119V14.5976H18.5442V15.1026ZM18.2917 9.22582V14.8501H18.7967V9.22582H18.2917ZM19.8495 7.45207C18.9664 7.56326 18.2917 8.31143 18.2917 9.22582H18.7967C18.7967 8.56753 19.2804 8.0327 19.9125 7.95311L19.8495 7.45207ZM19.8395 7.45581C19.8467 7.45307 19.8543 7.45138 19.862 7.4508L19.9 7.95437C19.9405 7.95132 19.9804 7.94246 20.0184 7.92806L19.8395 7.45581ZM20.0781 7.43944H19.9289V7.94444H20.0781V7.43944ZM21.8644 9.22582C21.8644 8.23365 21.0702 7.43944 20.0781 7.43944V7.94444C20.7913 7.94444 21.3594 8.51255 21.3594 9.22582H21.8644ZM10.9398 16.8876C10.9439 16.9324 10.9111 16.972 10.8664 16.9762L10.8192 16.4734C10.5863 16.4952 10.4151 16.7018 10.437 16.9348L10.9398 16.8876ZM10.8512 16.8143C10.8959 16.8101 10.9356 16.8429 10.9398 16.8876L10.437 16.9348C10.4588 17.1677 10.6654 17.3389 10.8983 17.3171L10.8512 16.8143ZM16.6694 16.8132H10.8748V17.3182H16.6694V16.8132ZM16.601 16.8539C16.6159 16.8283 16.6434 16.8128 16.673 16.8132L16.6659 17.3181C16.8184 17.3203 16.9602 17.2402 17.0371 17.1084L16.601 16.8539ZM16.601 16.9366C16.5861 16.911 16.5861 16.8794 16.601 16.8539L17.0371 17.1084C17.114 16.9767 17.114 16.8138 17.0371 16.682L16.601 16.9366ZM16.673 16.9773C16.6434 16.9777 16.6159 16.9622 16.601 16.9366L17.0371 16.682C16.9602 16.5503 16.8184 16.4702 16.6659 16.4723L16.673 16.9773ZM10.8748 16.9773H16.6694V16.4723H10.8748V16.9773ZM10.8665 16.9762C10.8614 16.9767 10.8562 16.9767 10.8511 16.9762L10.8984 16.4734C10.8721 16.4709 10.8455 16.4709 10.8191 16.4734L10.8665 16.9762ZM10.8192 18.8594C10.5863 18.8813 10.4151 19.0879 10.437 19.3208L10.9398 19.2737C10.9439 19.3184 10.9111 19.358 10.8664 19.3622L10.8192 18.8594ZM10.8984 18.8595C10.8721 18.857 10.8455 18.857 10.8191 18.8595L10.8665 19.3622C10.8614 19.3627 10.8562 19.3627 10.8511 19.3622L10.8984 18.8595ZM13.2608 18.8583H10.8748V19.3633H13.2608V18.8583ZM13.6285 19.0681C13.5516 18.9363 13.4097 18.8562 13.2572 18.8584L13.2644 19.3633C13.2348 19.3637 13.2073 19.3482 13.1923 19.3226L13.6285 19.0681ZM13.6285 19.4945C13.7054 19.3627 13.7054 19.1998 13.6285 19.0681L13.1923 19.3226C13.1774 19.2971 13.1774 19.2655 13.1923 19.2399L13.6285 19.4945ZM13.2572 19.7042C13.4097 19.7063 13.5516 19.6262 13.6285 19.4945L13.1923 19.2399C13.2073 19.2144 13.2348 19.1988 13.2644 19.1992L13.2572 19.7042ZM10.8748 19.7042H13.2608V19.1992H10.8748V19.7042ZM10.437 19.3208C10.4588 19.5538 10.6654 19.7249 10.8983 19.7031L10.8512 19.2003C10.8959 19.1961 10.9356 19.229 10.9398 19.2737L10.437 19.3208Z"
              fill="#253B95"
            />
            <path
              d="M12.8838 14.2705V11.5763C12.8838 11.3627 13.1695 11.2913 13.2699 11.4798L14.5746 13.9277C14.675 14.1161 14.9607 14.0454 14.9607 13.8319C14.9607 13.0517 14.9607 11.8702 14.9607 10.9914"
              stroke="#253B95"
              stroke-width="0.4"
            />
            <rect x="12" y="13.0954" width="4" height="0.4" fill="#253B95" />
            <rect x="12" y="12.1723" width="4" height="0.4" fill="#253B95" />
          </svg>

          <div
            class="
              ml-3
              tracking-wide
              uppercase
              tiny
              font-medium
              text-accentDark
            "
          >
            <p class="whitespace-no-wrap">Retail Store</p>
          </div>
          <svg
            @click="retailStoreToggle = !retailStoreToggle"
            class="w-3 h-3 ml-2 cursor-pointer"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7L13 1"
              stroke="#253B95"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div
          v-if="retailStoreToggle"
          class="mt-6 grid grid-cols-3 row-gap-8 items-start justify-start"
        >
          <div
            class="increase-spacing-nav"
            v-for="(store, i) in retailStore"
            :key="i"
          >
            <router-link
              class="flex justify-center items-center flex-col"
              :to="{ name: `${store.routeName || 'Dashboard'}` }"
            >
              <div class="w-6 h-6 rounded">
                <img
                  class="w-full h-full"
                  :src="getImgUrl(store.icon, 'retailStore')"
                  alt=""
                />
              </div>
              <div
                class="
                  very-tiny
                  text-center text-primaryGray
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                {{ store.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="mt-6">
        <div class="flex items-center">
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6.24237C0 2.92866 2.68629 0.242371 6 0.242371H24C27.3137 0.242371 30 2.92866 30 6.24237V24.2424C30 27.5561 27.3137 30.2424 24 30.2424H6C2.68629 30.2424 0 27.5561 0 24.2424V6.24237Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8694 7.35107C9.83777 7.37018 9.00002 8.19014 9.00002 9.22582V21.8377C8.99915 21.8992 9.03144 21.9564 9.08453 21.9874C9.12018 22.0082 9.1615 22.015 9.20088 22.0079C9.20518 22.0081 9.2095 22.0082 9.21385 22.0082H18.3737C18.4679 22.0082 18.5442 21.9319 18.5442 21.8377V15.1909H21.7824C21.8765 15.1909 21.9528 15.1146 21.9528 15.0205V9.22582C21.9528 8.19016 21.1137 7.35107 20.0781 7.35107H10.8748H10.8694ZM18.2033 21.6673H9.34088V9.22582C9.34088 8.37493 10.0209 7.71051 10.8748 7.69194H10.8801H18.9969C18.5173 8.03265 18.2033 8.59288 18.2033 9.22582V21.6673ZM21.6119 9.22582V14.8501H18.5442V9.22582C18.5442 8.43948 19.1234 7.79798 19.881 7.70259C19.8974 7.70135 19.9135 7.69777 19.9289 7.69194H20.0781C20.9308 7.69194 21.6119 8.3731 21.6119 9.22582ZM10.8428 16.7248C10.7487 16.7336 10.6795 16.8171 10.6884 16.9112C10.6972 17.0053 10.7806 17.0745 10.8748 17.0657H16.6694C16.7309 17.0665 16.7881 17.0342 16.8191 16.9812C16.85 16.9281 16.85 16.8624 16.8191 16.8093C16.7881 16.7562 16.7309 16.7239 16.6694 16.7248H10.8748C10.8641 16.7238 10.8534 16.7238 10.8428 16.7248ZM10.6884 19.2973C10.6795 19.2031 10.7487 19.1197 10.8428 19.1108C10.8534 19.1098 10.8641 19.1098 10.8748 19.1108H13.2608C13.3223 19.11 13.3794 19.1423 13.4104 19.1954C13.4414 19.2484 13.4414 19.3141 13.4104 19.3672C13.3794 19.4203 13.3223 19.4526 13.2608 19.4517H10.8748C10.7806 19.4605 10.6972 19.3914 10.6884 19.2973Z"
              fill="#253B95"
            />
            <path
              d="M10.8694 7.35107V7.09853L10.8648 7.09862L10.8694 7.35107ZM9.00002 21.8377L9.25252 21.8413V21.8377H9.00002ZM9.08453 21.9874L8.95725 22.2054L8.95725 22.2054L9.08453 21.9874ZM9.20088 22.0079L9.21647 21.7558L9.18594 21.754L9.15584 21.7594L9.20088 22.0079ZM9.21385 22.0082V21.7557L9.21031 21.7557L9.21385 22.0082ZM18.3737 22.0082V22.2607H18.3738L18.3737 22.0082ZM18.5442 21.8377L18.7967 21.8378V21.8377H18.5442ZM18.5442 15.1909V14.9384H18.2917V15.1909H18.5442ZM21.7824 15.1909V15.4434H21.7824L21.7824 15.1909ZM21.9528 15.0205L22.2053 15.0205V15.0205H21.9528ZM9.34088 21.6673H9.08838V21.9198H9.34088V21.6673ZM18.2033 21.6673V21.9198H18.4558V21.6673H18.2033ZM10.8748 7.69194V7.43938L10.8693 7.4395L10.8748 7.69194ZM18.9969 7.69194L19.1431 7.89779L19.7883 7.43944H18.9969V7.69194ZM21.6119 14.8501V15.1026H21.8644V14.8501H21.6119ZM18.5442 14.8501H18.2917V15.1026H18.5442V14.8501ZM19.881 7.70259L19.862 7.45049L19.8495 7.45207L19.881 7.70259ZM19.9289 7.69194V7.43944H19.8827L19.8395 7.45581L19.9289 7.69194ZM10.8428 16.7248L10.8664 16.9762L10.8665 16.9762L10.8428 16.7248ZM10.8748 17.0657V16.8132H10.863L10.8512 16.8143L10.8748 17.0657ZM16.6694 17.0657L16.673 16.8132H16.6694V17.0657ZM16.8191 16.9812L17.0371 17.1084L17.0371 17.1084L16.8191 16.9812ZM16.8191 16.8093L17.0371 16.682L17.0371 16.682L16.8191 16.8093ZM16.6694 16.7248V16.9773L16.673 16.9773L16.6694 16.7248ZM10.8748 16.7248L10.8511 16.9762L10.8629 16.9773H10.8748V16.7248ZM10.8428 19.1108L10.8664 19.3622L10.8665 19.3622L10.8428 19.1108ZM10.8748 19.1108L10.8511 19.3622L10.8629 19.3633H10.8748V19.1108ZM13.2608 19.1108V19.3634L13.2644 19.3633L13.2608 19.1108ZM13.4104 19.1954L13.1923 19.3226L13.1923 19.3226L13.4104 19.1954ZM13.4104 19.3672L13.6285 19.4945V19.4945L13.4104 19.3672ZM13.2608 19.4517L13.2644 19.1992H13.2608V19.4517ZM10.8748 19.4517V19.1992H10.863L10.8512 19.2003L10.8748 19.4517ZM9.25252 9.22582C9.25252 8.33319 9.97456 7.62019 10.8741 7.60353L10.8648 7.09862C9.70097 7.12017 8.74752 8.04709 8.74752 9.22582H9.25252ZM9.25252 21.8377V9.22582H8.74752V21.8377H9.25252ZM9.21181 21.7693C9.23736 21.7842 9.25291 21.8117 9.25249 21.8413L8.74754 21.8342C8.74539 21.9867 8.82552 22.1286 8.95725 22.2054L9.21181 21.7693ZM9.15584 21.7594C9.17469 21.756 9.19461 21.7593 9.21181 21.7693L8.95725 22.2054C9.04575 22.2571 9.14831 22.274 9.24592 22.2563L9.15584 21.7594ZM9.21031 21.7557C9.21237 21.7557 9.21443 21.7557 9.21647 21.7558L9.18528 22.2599C9.19592 22.2605 9.20664 22.2608 9.2174 22.2607L9.21031 21.7557ZM18.3737 21.7557H9.21385V22.2607H18.3737V21.7557ZM18.2917 21.8377C18.2917 21.7924 18.3284 21.7557 18.3737 21.7557L18.3738 22.2607C18.6073 22.2607 18.7967 22.0713 18.7967 21.8378L18.2917 21.8377ZM18.2917 15.1909V21.8377H18.7967V15.1909H18.2917ZM21.7824 14.9384H18.5442V15.4434H21.7824V14.9384ZM21.7003 15.0205C21.7003 14.9752 21.737 14.9384 21.7823 14.9384L21.7824 15.4434C22.016 15.4434 22.2053 15.2541 22.2053 15.0205L21.7003 15.0205ZM21.7003 9.22582V15.0205H22.2053V9.22582H21.7003ZM20.0781 7.60357C20.9743 7.60357 21.7003 8.32961 21.7003 9.22582H22.2053C22.2053 8.05071 21.2532 7.09857 20.0781 7.09857V7.60357ZM10.8748 7.60357H20.0781V7.09857H10.8748V7.60357ZM10.8694 7.60357H10.8748V7.09857H10.8694V7.60357ZM9.34088 21.9198H18.2033V21.4148H9.34088V21.9198ZM9.08838 9.22582V21.6673H9.59338V9.22582H9.08838ZM10.8693 7.4395C9.88501 7.46091 9.08838 8.23088 9.08838 9.22582H9.59338C9.59338 8.51899 10.1569 7.96011 10.8803 7.94438L10.8693 7.4395ZM10.8801 7.43944H10.8748V7.94444H10.8801V7.43944ZM18.9969 7.43944H10.8801V7.94444H18.9969V7.43944ZM18.4558 9.22582C18.4558 8.67837 18.7271 8.19333 19.1431 7.89779L18.8507 7.48609C18.3074 7.87197 17.9508 8.50738 17.9508 9.22582H18.4558ZM18.4558 21.6673V9.22582H17.9508V21.6673H18.4558ZM21.8644 14.8501V9.22582H21.3594V14.8501H21.8644ZM18.5442 15.1026H21.6119V14.5976H18.5442V15.1026ZM18.2917 9.22582V14.8501H18.7967V9.22582H18.2917ZM19.8495 7.45207C18.9664 7.56326 18.2917 8.31143 18.2917 9.22582H18.7967C18.7967 8.56753 19.2804 8.0327 19.9125 7.95311L19.8495 7.45207ZM19.8395 7.45581C19.8467 7.45307 19.8543 7.45138 19.862 7.4508L19.9 7.95437C19.9405 7.95132 19.9804 7.94246 20.0184 7.92806L19.8395 7.45581ZM20.0781 7.43944H19.9289V7.94444H20.0781V7.43944ZM21.8644 9.22582C21.8644 8.23365 21.0702 7.43944 20.0781 7.43944V7.94444C20.7913 7.94444 21.3594 8.51255 21.3594 9.22582H21.8644ZM10.9398 16.8876C10.9439 16.9324 10.9111 16.972 10.8664 16.9762L10.8192 16.4734C10.5863 16.4952 10.4151 16.7018 10.437 16.9348L10.9398 16.8876ZM10.8512 16.8143C10.8959 16.8101 10.9356 16.8429 10.9398 16.8876L10.437 16.9348C10.4588 17.1677 10.6654 17.3389 10.8983 17.3171L10.8512 16.8143ZM16.6694 16.8132H10.8748V17.3182H16.6694V16.8132ZM16.601 16.8539C16.6159 16.8283 16.6434 16.8128 16.673 16.8132L16.6659 17.3181C16.8184 17.3203 16.9602 17.2402 17.0371 17.1084L16.601 16.8539ZM16.601 16.9366C16.5861 16.911 16.5861 16.8794 16.601 16.8539L17.0371 17.1084C17.114 16.9767 17.114 16.8138 17.0371 16.682L16.601 16.9366ZM16.673 16.9773C16.6434 16.9777 16.6159 16.9622 16.601 16.9366L17.0371 16.682C16.9602 16.5503 16.8184 16.4702 16.6659 16.4723L16.673 16.9773ZM10.8748 16.9773H16.6694V16.4723H10.8748V16.9773ZM10.8665 16.9762C10.8614 16.9767 10.8562 16.9767 10.8511 16.9762L10.8984 16.4734C10.8721 16.4709 10.8455 16.4709 10.8191 16.4734L10.8665 16.9762ZM10.8192 18.8594C10.5863 18.8813 10.4151 19.0879 10.437 19.3208L10.9398 19.2737C10.9439 19.3184 10.9111 19.358 10.8664 19.3622L10.8192 18.8594ZM10.8984 18.8595C10.8721 18.857 10.8455 18.857 10.8191 18.8595L10.8665 19.3622C10.8614 19.3627 10.8562 19.3627 10.8511 19.3622L10.8984 18.8595ZM13.2608 18.8583H10.8748V19.3633H13.2608V18.8583ZM13.6285 19.0681C13.5516 18.9363 13.4097 18.8562 13.2572 18.8584L13.2644 19.3633C13.2348 19.3637 13.2073 19.3482 13.1923 19.3226L13.6285 19.0681ZM13.6285 19.4945C13.7054 19.3627 13.7054 19.1998 13.6285 19.0681L13.1923 19.3226C13.1774 19.2971 13.1774 19.2655 13.1923 19.2399L13.6285 19.4945ZM13.2572 19.7042C13.4097 19.7063 13.5516 19.6262 13.6285 19.4945L13.1923 19.2399C13.2073 19.2144 13.2348 19.1988 13.2644 19.1992L13.2572 19.7042ZM10.8748 19.7042H13.2608V19.1992H10.8748V19.7042ZM10.437 19.3208C10.4588 19.5538 10.6654 19.7249 10.8983 19.7031L10.8512 19.2003C10.8959 19.1961 10.9356 19.229 10.9398 19.2737L10.437 19.3208Z"
              fill="#253B95"
            />
            <path
              d="M12.8838 14.2705V11.5763C12.8838 11.3627 13.1695 11.2913 13.2699 11.4798L14.5746 13.9277C14.675 14.1161 14.9607 14.0454 14.9607 13.8319C14.9607 13.0517 14.9607 11.8702 14.9607 10.9914"
              stroke="#253B95"
              stroke-width="0.4"
            />
            <rect x="12" y="13.0954" width="4" height="0.4" fill="#253B95" />
            <rect x="12" y="12.1723" width="4" height="0.4" fill="#253B95" />
          </svg>

          <div
            class="
              ml-3
              tracking-wide
              uppercase
              tiny
              font-medium
              text-accentDark
            "
          >
            <p class="whitespace-no-wrap">Online Store</p>
          </div>
          <svg
            @click="onlineStoreToggle = !onlineStoreToggle"
            class="w-3 h-3 ml-2 cursor-pointer"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7L13 1"
              stroke="#253B95"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div
          v-if="onlineStoreToggle"
          class="mt-6 grid grid-cols-3 row-gap-8 items-start justify-start"
        >
          <div
            class="increase-spacing-nav"
            v-for="(store, i) in onlineStore"
            :key="i"
          >
            <router-link
              class="flex justify-center items-center flex-col"
              :to="{ name: `${store.routeName || 'Dashboard'}` }"
            >
              <div class="w-6 h-6 rounded">
                <img
                  class="w-full h-full"
                  :src="getImgUrl(store.icon, 'onlineStore')"
                  alt=""
                />
              </div>
              <div
                class="
                  very-tiny
                  text-center text-primaryGray
                  bottom-0
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                {{ store.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="mt-6">
        <router-link class="flex items-center" to="/dashboard">
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6.24237C0 2.92866 2.68629 0.242371 6 0.242371H24C27.3137 0.242371 30 2.92866 30 6.24237V24.2424C30 27.5561 27.3137 30.2424 24 30.2424H6C2.68629 30.2424 0 27.5561 0 24.2424V6.24237Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8694 7.35107C9.83777 7.37018 9.00002 8.19014 9.00002 9.22582V21.8377C8.99915 21.8992 9.03144 21.9564 9.08453 21.9874C9.12018 22.0082 9.1615 22.015 9.20088 22.0079C9.20518 22.0081 9.2095 22.0082 9.21385 22.0082H18.3737C18.4679 22.0082 18.5442 21.9319 18.5442 21.8377V15.1909H21.7824C21.8765 15.1909 21.9528 15.1146 21.9528 15.0205V9.22582C21.9528 8.19016 21.1137 7.35107 20.0781 7.35107H10.8748H10.8694ZM18.2033 21.6673H9.34088V9.22582C9.34088 8.37493 10.0209 7.71051 10.8748 7.69194H10.8801H18.9969C18.5173 8.03265 18.2033 8.59288 18.2033 9.22582V21.6673ZM21.6119 9.22582V14.8501H18.5442V9.22582C18.5442 8.43948 19.1234 7.79798 19.881 7.70259C19.8974 7.70135 19.9135 7.69777 19.9289 7.69194H20.0781C20.9308 7.69194 21.6119 8.3731 21.6119 9.22582ZM10.8428 16.7248C10.7487 16.7336 10.6795 16.8171 10.6884 16.9112C10.6972 17.0053 10.7806 17.0745 10.8748 17.0657H16.6694C16.7309 17.0665 16.7881 17.0342 16.8191 16.9812C16.85 16.9281 16.85 16.8624 16.8191 16.8093C16.7881 16.7562 16.7309 16.7239 16.6694 16.7248H10.8748C10.8641 16.7238 10.8534 16.7238 10.8428 16.7248ZM10.6884 19.2973C10.6795 19.2031 10.7487 19.1197 10.8428 19.1108C10.8534 19.1098 10.8641 19.1098 10.8748 19.1108H13.2608C13.3223 19.11 13.3794 19.1423 13.4104 19.1954C13.4414 19.2484 13.4414 19.3141 13.4104 19.3672C13.3794 19.4203 13.3223 19.4526 13.2608 19.4517H10.8748C10.7806 19.4605 10.6972 19.3914 10.6884 19.2973Z"
              fill="#253B95"
            />
            <path
              d="M10.8694 7.35107V7.09853L10.8648 7.09862L10.8694 7.35107ZM9.00002 21.8377L9.25252 21.8413V21.8377H9.00002ZM9.08453 21.9874L8.95725 22.2054L8.95725 22.2054L9.08453 21.9874ZM9.20088 22.0079L9.21647 21.7558L9.18594 21.754L9.15584 21.7594L9.20088 22.0079ZM9.21385 22.0082V21.7557L9.21031 21.7557L9.21385 22.0082ZM18.3737 22.0082V22.2607H18.3738L18.3737 22.0082ZM18.5442 21.8377L18.7967 21.8378V21.8377H18.5442ZM18.5442 15.1909V14.9384H18.2917V15.1909H18.5442ZM21.7824 15.1909V15.4434H21.7824L21.7824 15.1909ZM21.9528 15.0205L22.2053 15.0205V15.0205H21.9528ZM9.34088 21.6673H9.08838V21.9198H9.34088V21.6673ZM18.2033 21.6673V21.9198H18.4558V21.6673H18.2033ZM10.8748 7.69194V7.43938L10.8693 7.4395L10.8748 7.69194ZM18.9969 7.69194L19.1431 7.89779L19.7883 7.43944H18.9969V7.69194ZM21.6119 14.8501V15.1026H21.8644V14.8501H21.6119ZM18.5442 14.8501H18.2917V15.1026H18.5442V14.8501ZM19.881 7.70259L19.862 7.45049L19.8495 7.45207L19.881 7.70259ZM19.9289 7.69194V7.43944H19.8827L19.8395 7.45581L19.9289 7.69194ZM10.8428 16.7248L10.8664 16.9762L10.8665 16.9762L10.8428 16.7248ZM10.8748 17.0657V16.8132H10.863L10.8512 16.8143L10.8748 17.0657ZM16.6694 17.0657L16.673 16.8132H16.6694V17.0657ZM16.8191 16.9812L17.0371 17.1084L17.0371 17.1084L16.8191 16.9812ZM16.8191 16.8093L17.0371 16.682L17.0371 16.682L16.8191 16.8093ZM16.6694 16.7248V16.9773L16.673 16.9773L16.6694 16.7248ZM10.8748 16.7248L10.8511 16.9762L10.8629 16.9773H10.8748V16.7248ZM10.8428 19.1108L10.8664 19.3622L10.8665 19.3622L10.8428 19.1108ZM10.8748 19.1108L10.8511 19.3622L10.8629 19.3633H10.8748V19.1108ZM13.2608 19.1108V19.3634L13.2644 19.3633L13.2608 19.1108ZM13.4104 19.1954L13.1923 19.3226L13.1923 19.3226L13.4104 19.1954ZM13.4104 19.3672L13.6285 19.4945V19.4945L13.4104 19.3672ZM13.2608 19.4517L13.2644 19.1992H13.2608V19.4517ZM10.8748 19.4517V19.1992H10.863L10.8512 19.2003L10.8748 19.4517ZM9.25252 9.22582C9.25252 8.33319 9.97456 7.62019 10.8741 7.60353L10.8648 7.09862C9.70097 7.12017 8.74752 8.04709 8.74752 9.22582H9.25252ZM9.25252 21.8377V9.22582H8.74752V21.8377H9.25252ZM9.21181 21.7693C9.23736 21.7842 9.25291 21.8117 9.25249 21.8413L8.74754 21.8342C8.74539 21.9867 8.82552 22.1286 8.95725 22.2054L9.21181 21.7693ZM9.15584 21.7594C9.17469 21.756 9.19461 21.7593 9.21181 21.7693L8.95725 22.2054C9.04575 22.2571 9.14831 22.274 9.24592 22.2563L9.15584 21.7594ZM9.21031 21.7557C9.21237 21.7557 9.21443 21.7557 9.21647 21.7558L9.18528 22.2599C9.19592 22.2605 9.20664 22.2608 9.2174 22.2607L9.21031 21.7557ZM18.3737 21.7557H9.21385V22.2607H18.3737V21.7557ZM18.2917 21.8377C18.2917 21.7924 18.3284 21.7557 18.3737 21.7557L18.3738 22.2607C18.6073 22.2607 18.7967 22.0713 18.7967 21.8378L18.2917 21.8377ZM18.2917 15.1909V21.8377H18.7967V15.1909H18.2917ZM21.7824 14.9384H18.5442V15.4434H21.7824V14.9384ZM21.7003 15.0205C21.7003 14.9752 21.737 14.9384 21.7823 14.9384L21.7824 15.4434C22.016 15.4434 22.2053 15.2541 22.2053 15.0205L21.7003 15.0205ZM21.7003 9.22582V15.0205H22.2053V9.22582H21.7003ZM20.0781 7.60357C20.9743 7.60357 21.7003 8.32961 21.7003 9.22582H22.2053C22.2053 8.05071 21.2532 7.09857 20.0781 7.09857V7.60357ZM10.8748 7.60357H20.0781V7.09857H10.8748V7.60357ZM10.8694 7.60357H10.8748V7.09857H10.8694V7.60357ZM9.34088 21.9198H18.2033V21.4148H9.34088V21.9198ZM9.08838 9.22582V21.6673H9.59338V9.22582H9.08838ZM10.8693 7.4395C9.88501 7.46091 9.08838 8.23088 9.08838 9.22582H9.59338C9.59338 8.51899 10.1569 7.96011 10.8803 7.94438L10.8693 7.4395ZM10.8801 7.43944H10.8748V7.94444H10.8801V7.43944ZM18.9969 7.43944H10.8801V7.94444H18.9969V7.43944ZM18.4558 9.22582C18.4558 8.67837 18.7271 8.19333 19.1431 7.89779L18.8507 7.48609C18.3074 7.87197 17.9508 8.50738 17.9508 9.22582H18.4558ZM18.4558 21.6673V9.22582H17.9508V21.6673H18.4558ZM21.8644 14.8501V9.22582H21.3594V14.8501H21.8644ZM18.5442 15.1026H21.6119V14.5976H18.5442V15.1026ZM18.2917 9.22582V14.8501H18.7967V9.22582H18.2917ZM19.8495 7.45207C18.9664 7.56326 18.2917 8.31143 18.2917 9.22582H18.7967C18.7967 8.56753 19.2804 8.0327 19.9125 7.95311L19.8495 7.45207ZM19.8395 7.45581C19.8467 7.45307 19.8543 7.45138 19.862 7.4508L19.9 7.95437C19.9405 7.95132 19.9804 7.94246 20.0184 7.92806L19.8395 7.45581ZM20.0781 7.43944H19.9289V7.94444H20.0781V7.43944ZM21.8644 9.22582C21.8644 8.23365 21.0702 7.43944 20.0781 7.43944V7.94444C20.7913 7.94444 21.3594 8.51255 21.3594 9.22582H21.8644ZM10.9398 16.8876C10.9439 16.9324 10.9111 16.972 10.8664 16.9762L10.8192 16.4734C10.5863 16.4952 10.4151 16.7018 10.437 16.9348L10.9398 16.8876ZM10.8512 16.8143C10.8959 16.8101 10.9356 16.8429 10.9398 16.8876L10.437 16.9348C10.4588 17.1677 10.6654 17.3389 10.8983 17.3171L10.8512 16.8143ZM16.6694 16.8132H10.8748V17.3182H16.6694V16.8132ZM16.601 16.8539C16.6159 16.8283 16.6434 16.8128 16.673 16.8132L16.6659 17.3181C16.8184 17.3203 16.9602 17.2402 17.0371 17.1084L16.601 16.8539ZM16.601 16.9366C16.5861 16.911 16.5861 16.8794 16.601 16.8539L17.0371 17.1084C17.114 16.9767 17.114 16.8138 17.0371 16.682L16.601 16.9366ZM16.673 16.9773C16.6434 16.9777 16.6159 16.9622 16.601 16.9366L17.0371 16.682C16.9602 16.5503 16.8184 16.4702 16.6659 16.4723L16.673 16.9773ZM10.8748 16.9773H16.6694V16.4723H10.8748V16.9773ZM10.8665 16.9762C10.8614 16.9767 10.8562 16.9767 10.8511 16.9762L10.8984 16.4734C10.8721 16.4709 10.8455 16.4709 10.8191 16.4734L10.8665 16.9762ZM10.8192 18.8594C10.5863 18.8813 10.4151 19.0879 10.437 19.3208L10.9398 19.2737C10.9439 19.3184 10.9111 19.358 10.8664 19.3622L10.8192 18.8594ZM10.8984 18.8595C10.8721 18.857 10.8455 18.857 10.8191 18.8595L10.8665 19.3622C10.8614 19.3627 10.8562 19.3627 10.8511 19.3622L10.8984 18.8595ZM13.2608 18.8583H10.8748V19.3633H13.2608V18.8583ZM13.6285 19.0681C13.5516 18.9363 13.4097 18.8562 13.2572 18.8584L13.2644 19.3633C13.2348 19.3637 13.2073 19.3482 13.1923 19.3226L13.6285 19.0681ZM13.6285 19.4945C13.7054 19.3627 13.7054 19.1998 13.6285 19.0681L13.1923 19.3226C13.1774 19.2971 13.1774 19.2655 13.1923 19.2399L13.6285 19.4945ZM13.2572 19.7042C13.4097 19.7063 13.5516 19.6262 13.6285 19.4945L13.1923 19.2399C13.2073 19.2144 13.2348 19.1988 13.2644 19.1992L13.2572 19.7042ZM10.8748 19.7042H13.2608V19.1992H10.8748V19.7042ZM10.437 19.3208C10.4588 19.5538 10.6654 19.7249 10.8983 19.7031L10.8512 19.2003C10.8959 19.1961 10.9356 19.229 10.9398 19.2737L10.437 19.3208Z"
              fill="#253B95"
            />
            <path
              d="M12.8838 14.2705V11.5763C12.8838 11.3627 13.1695 11.2913 13.2699 11.4798L14.5746 13.9277C14.675 14.1161 14.9607 14.0454 14.9607 13.8319C14.9607 13.0517 14.9607 11.8702 14.9607 10.9914"
              stroke="#253B95"
              stroke-width="0.4"
            />
            <rect x="12" y="13.0954" width="4" height="0.4" fill="#253B95" />
            <rect x="12" y="12.1723" width="4" height="0.4" fill="#253B95" />
          </svg>
          <div
            class="ml-3 tracking-wide uppercase tiny font-medium text-accentDark"
          >
            <p class="whitespace-no-wrap">WHOLESALE MARKETPlACE</p>
          </div>
        </router-link>
      </div> -->
      <div class="mt-6">
        <div class="flex items-center" to="/dashboard">
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6.24237C0 2.92866 2.68629 0.242371 6 0.242371H24C27.3137 0.242371 30 2.92866 30 6.24237V24.2424C30 27.5561 27.3137 30.2424 24 30.2424H6C2.68629 30.2424 0 27.5561 0 24.2424V6.24237Z"
              fill="#EFFAFF"
            />
            <path
              d="M21.5 23.2424V21.5757C21.5 19.7348 20.0076 18.2424 18.1667 18.2424H12.3333C10.4924 18.2424 9 19.7348 9 21.5757V23.2424"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="15.2503"
              cy="11.5757"
              r="3.33333"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div
            class="
              ml-3
              tracking-wide
              uppercase
              tiny
              font-medium
              text-accentDark
            "
          >
            <p class="whitespace-no-wrap">PROFILE</p>
          </div>
          <svg
            @click="profileToggle = !profileToggle"
            class="w-3 h-3 ml-2 cursor-pointer"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7L13 1"
              stroke="#253B95"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div
          v-if="profileToggle"
          class="mt-6 grid grid-cols-3 row-gap-8 items-start justify-start"
        >
          <div
            class="increase-spacing-nav"
            v-for="(store, i) in profile"
            :key="i"
          >
            <router-link
              class="flex justify-center items-center flex-col"
              :to="{ name: `${store.routeName || 'Dashboard'}` }"
            >
              <div class="w-6 h-6 rounded">
                <img
                  class="w-full h-full"
                  :src="getImgUrl(store.icon, 'profile')"
                  alt=""
                />
              </div>
              <div
                class="
                  very-tiny
                  text-center text-primaryGray
                  bottom-0
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                {{ store.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="mt-6">
        <div id="settingToggle" class="inline-flex items-center">
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6C0 2.68629 2.68629 0 6 0H24C27.3137 0 30 2.68629 30 6V24C30 27.3137 27.3137 30 24 30H6C2.68629 30 0 27.3137 0 24V6Z"
              fill="#EFFAFF"
            />
            <ellipse
              cx="15.4323"
              cy="15.4323"
              rx="2.02703"
              ry="2.02704"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.4324 17.4595C20.2484 17.8764 20.3367 18.3634 20.6554 18.6892L20.696 18.7297C20.9497 18.9832 21.0923 19.3272 21.0923 19.6858C21.0923 20.0445 20.9497 20.3884 20.696 20.6419C20.4425 20.8956 20.0985 21.0382 19.7399 21.0382C19.3812 21.0382 19.0373 20.8956 18.7838 20.6419L18.7432 20.6014C18.4174 20.2827 17.9305 20.1944 17.5135 20.3784C17.1051 20.5534 16.8396 20.9543 16.8378 21.3987V21.5135C16.8378 22.2598 16.2328 22.8649 15.4865 22.8649C14.7402 22.8649 14.1351 22.2598 14.1351 21.5135V21.4527C14.1244 20.9951 13.8351 20.5905 13.4054 20.4324C12.9885 20.2484 12.5015 20.3367 12.1757 20.6554L12.1351 20.6959C11.8817 20.9497 11.5377 21.0923 11.1791 21.0923C10.8204 21.0923 10.4764 20.9497 10.223 20.6959C9.96922 20.4425 9.82664 20.0985 9.82664 19.7399C9.82664 19.3812 9.96922 19.0373 10.223 18.7838L10.2635 18.7432C10.5822 18.4174 10.6705 17.9305 10.4865 17.5135C10.3114 17.1051 9.91057 16.8396 9.46622 16.8378H9.35135C8.60502 16.8378 8 16.2328 8 15.4865C8 14.7402 8.60502 14.1351 9.35135 14.1351H9.41216C9.86982 14.1244 10.2744 13.8351 10.4324 13.4054C10.6165 12.9885 10.5282 12.5015 10.2095 12.1757L10.1689 12.1351C9.91517 11.8817 9.77259 11.5377 9.77259 11.1791C9.77259 10.8204 9.91517 10.4764 10.1689 10.223C10.4224 9.96922 10.7663 9.82664 11.125 9.82664C11.4837 9.82664 11.8276 9.96922 12.0811 10.223L12.1216 10.2635C12.4474 10.5822 12.9344 10.6705 13.3514 10.4865H13.4054C13.8138 10.3114 14.0793 9.91057 14.0811 9.46622V9.35135C14.0811 8.60502 14.6861 8 15.4324 8C16.1788 8 16.7838 8.60502 16.7838 9.35135V9.41216C16.7856 9.85652 17.051 10.2574 17.4595 10.4324C17.8764 10.6165 18.3634 10.5282 18.6892 10.2095L18.7297 10.1689C18.9832 9.91517 19.3272 9.77259 19.6858 9.77259C20.0445 9.77259 20.3884 9.91517 20.6419 10.1689C20.8957 10.4224 21.0382 10.7663 21.0382 11.125C21.0382 11.4837 20.8957 11.8276 20.6419 12.0811L20.6014 12.1216C20.2827 12.4474 20.1944 12.9344 20.3784 13.3514V13.4054C20.5534 13.8138 20.9543 14.0793 21.3987 14.0811H21.5135C22.2599 14.0811 22.8649 14.6861 22.8649 15.4324C22.8649 16.1788 22.2599 16.7838 21.5135 16.7838H21.4527C21.0084 16.7856 20.6075 17.051 20.4324 17.4595Z"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div
            class="
              ml-3
              tracking-wide
              uppercase
              tiny
              font-medium
              text-accentDark
            "
          >
            <p class="whitespace-no-wrap">SETTINGS</p>
          </div>
          <svg
            @click="settingToggle = !settingToggle"
            class="w-3 h-3 ml-2 cursor-pointer"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7L13 1"
              stroke="#253B95"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div
          v-if="settingToggle"
          class="mt-6 grid grid-cols-3 row-gap-8 items-start justify-start"
        >
          <div
            :id="set.routeName"
            class="increase-spacing-nav"
            v-for="(set, i) in settings"
            :key="i"
          >
            <router-link
              v-if="getBusinesData || set.name !== 'settlement Account'"
              class="flex justify-center items-center flex-col"
              :to="{ name: `${set.routeName || 'Dashboard'}` }"
            >
              <div class="w-6 h-6 rounded">
                <img
                  v-if="
                    set.name != 'settlement Account' &&
                    id == '60ae21bcb4712a00037a59ab'
                  "
                  class="w-full h-full"
                  :src="getImgUrl(set.icon, 'settings')"
                  alt=""
                />
                <img
                  v-else-if="id != '60ae21bcb4712a00037a59ab'"
                  class="w-full h-full"
                  :src="getImgUrl(set.icon, 'settings')"
                  alt=""
                />
              </div>
              <div
                v-if="
                  set.name != 'settlement Account' &&
                  id == '60ae21bcb4712a00037a59ab'
                "
                class="
                  very-tiny
                  text-center text-primaryGray
                  bottom-0
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                {{ set.name }}
              </div>
              <div
                v-else-if="id != '60ae21bcb4712a00037a59ab'"
                class="
                  very-tiny
                  text-center text-primaryGray
                  bottom-0
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                {{ set.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="mt-6">
        <div class="flex items-center">
          <svg
            class="-ml-1"
            height="30px"
            width="30px"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 6C0 2.68629 2.68629 0 6 0H24C27.3137 0 30 2.68629 30 6V24C30 27.3137 27.3137 30 24 30H6C2.68629 30 0 27.3137 0 24V6Z"
              fill="#EFFAFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.7057 18.9707V21.1765C22.7073 21.5906 22.5344 21.9862 22.2292 22.2661C21.9241 22.5461 21.5151 22.6844 21.1027 22.6471C18.8401 22.4013 16.6667 21.6281 14.7571 20.3898C12.9805 19.2609 11.4743 17.7546 10.3454 15.978C9.10269 14.0598 8.32936 11.8758 8.088 9.60301C8.05085 9.19189 8.1882 8.78408 8.46651 8.47921C8.74481 8.17433 9.13844 8.00046 9.55124 8.00007H11.7571C12.4953 7.99281 13.1244 8.53387 13.2277 9.26478C13.3208 9.97071 13.4935 10.6638 13.7424 11.331C13.9444 11.8684 13.8152 12.4742 13.4115 12.8824L12.4777 13.8162C13.5244 15.6571 15.0486 17.1813 16.8895 18.228L17.8233 17.2942C18.2315 16.8905 18.8374 16.7613 19.3748 16.9633C20.0419 17.2122 20.735 17.3849 21.4409 17.478C22.1803 17.5823 22.7242 18.2242 22.7057 18.9707Z"
              stroke="#253B95"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div
            class="
              ml-3
              tracking-wide
              uppercase
              tiny
              font-medium
              text-accentDark
            "
          >
            <p class="whitespace-no-wrap">Support &amp; Policies</p>
          </div>
          <svg
            @click="supportToggle = !supportToggle"
            class="w-3 h-3 ml-2 cursor-pointer"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7L13 1"
              stroke="#253B95"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div
          v-if="supportToggle"
          class="mt-6 grid grid-cols-3 row-gap-8 items-start justify-start"
        >
          <div class="increase-spacing-nav ml-16">
            <a
              href="mailto:support@tractionapps.co"
              class="
                flex
                justify-center
                items-center
                flex-col
                pl-8
                cursor-pointer
              "
            >
              <div class="w-6 h-6 rounded">
                <img
                  class="w-full h-full"
                  src="@/assets/svg/routes/support/customerCare.svg"
                  alt=""
                />
              </div>
              <div
                class="
                  very-tiny
                  text-center text-primaryGray
                  bottom-0
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                Customer Care
              </div>
            </a>
            <a
              class="
                flex
                justify-center
                items-center
                flex-col
                pl-6
                cursor-pointer
              "
            >
              <div class="w-6 h-6 rounded">
                <img
                  class="w-full h-full"
                  src="@/assets/svg/routes/support/terms.svg"
                  alt=""
                />
              </div>
              <div
                class="
                  very-tiny
                  text-center text-primaryGray
                  bottom-0
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                Terms &amp; Conditions
              </div>
            </a>
            <router-link
              :to="{ name: 'UserGuides' }"
              class="
                flex
                justify-center
                items-center
                flex-col
                pl-6
                cursor-pointer
              "
            >
              <div class="w-6 h-6 rounded">
                <img
                  class="w-full h-full"
                  src="@/assets/svg/routes/support/terms.svg"
                  alt=""
                />
              </div>
              <div
                class="
                  very-tiny
                  text-center text-primaryGray
                  bottom-0
                  uppercase
                  items-center
                  pl-1
                  pt-2
                "
              >
                User Guides
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  CLEAR_ALL_DATA_IN_DB,
  CLEAR_KEY_IN_DB,
  CLEAR_LIST,
} from "../../browser-db-config/indexedDB";
import {
  DELETE_AUTH_USER,
  DELETE_LOCAL_DB_DATA,
  GET_USER_BUSINESS_DATA,
  GET_USER_BUSINESS_ID,
  GET_USER_DATA,
} from "../../browser-db-config/localStorage";
import { permissionsModules } from "./../../views/settings/permission";

export default {
  data() {
    return {
      id: null,
      active: false,
      businessServicesToggle: false,
      retailStoreToggle: false,
      onlineStoreToggle: false,
      profileToggle: false,
      settingToggle: false,
      supportToggle: false,
      permissionsModules,
      authRole: GET_USER_DATA().role ? GET_USER_DATA().role.toLowerCase() : '',
      businessServices: [
        {
          name: "transactions",
          icon: "transactions.svg",
          routeName: "Payments",
        },
        {
          name: "categories",
          icon: "invoices.svg",
          routeName: "Categories",
        },
        {
          name: "sales",
          icon: "sales.svg",
          routeName: "SalesHistory",
        },
        {
          name: "customers",
          icon: "customers.svg",
          routeName: "Customers",
        },
        {
          name: `customer 
          loyalty`,
          icon: "customers.svg",
          routeName: "CustomerLoyalty",
        },
        {
          name: "invoices",
          icon: "invoices.svg",
          routeName: "Invoices",
        },
        {
          name: "Insights",
          icon: "insights.svg",
          routeName: "Insights",
        },
        {
          name: "Ticket",
          icon: "tickets.svg",
          routeName: "Tickets",
        },
        {
          name: "Wallet",
          icon: "wallet.svg",
          routeName: "MainWallet",
        },
        // {
        //   name: 'account',
        //   icon: 'account.svg',
        //   routeName: null
        // },
        // {
        //   name: 'loans',
        //   icon: 'loans.svg',
        //   routeName: null
        // },

        // {
        //   name: 'wallet',
        //   icon: 'wallet.svg',
        //   routeName: null
        // },
        // {
        //   name: 'credit book',
        //   icon: 'creditBook.svg',
        //   routeName: null
        // },
      ],
      retailStore: [
        {
          name: "point of sale",
          icon: "pointOfSale.svg",
          routeName: "Pos",
        },
        {
          name: "my products",
          icon: "myProducts.svg",
          routeName: "Products",
        },
        // {
        //   name: "digital goods",
        //   icon: "pointOfSale.svg",
        //   routeName: "DigitalGoods",
        // },
        {
          name: "inventory transfer",
          icon: "inventoryManagement.svg",
          routeName: "InventoryTransfer",
        },
        {
          name: "stock count",
          icon: "inventoryManagement.svg",
          routeName: "StockCount",
        },
        {
          name: "stock adjustment",
          icon: "inventoryManagement.svg",
          routeName: "StockAdjustment",
        },
        {
          name: "print label",
          icon: "printLabel.svg",
          routeName: "PrintLabel",
        },
        // {
        //   name: 'registers',
        //   icon: 'registers.svg',
        //   routeName: 'Registers'
        // },
      ],
      onlineStore: [
        {
          name: "online catalog",
          icon: "onlineCatalog.svg",
          routeName: "OnlineCatalogue",
        },
        {
          name: "online orders",
          icon: "onlineOrders.svg",
          routeName: "Orders",
        },
      ],
      profile: [
        {
          name: "business profile",
          icon: "businessProfile.svg",
          routeName: "CompanyInfo",
        },
        {
          name: "manage users",
          icon: "manageUsers.svg",
          routeName: "UserRoles",
        },
        {
          name: "All Stores",
          icon: "manageUsers.svg",
          routeName: "AllStores",
        },
        {
          name: "Kyc",
          icon: "manageUsers.svg",
          routeName: "Kyc",
        },
      ],
      settings: [
        {
          name: "Payment Methods",
          icon: "notificationSettings.svg",
          routeName: "PaymentMethod",
        },
        {
          name: "Hardware",
          icon: "hardwareSettings.svg",
          routeName: "Hardware",
        },
        {
          name: "Integrations",
          icon: "settlementSettings.svg",
          routeName: "Integrations",
        },
        {
          name: "My Traction Accounts",
          icon: "settlementSettings.svg",
          routeName: "FixedAccount",
        },
        {
          name: "My Sync Settings",
          icon: "syncing.svg",
          routeName: "SyncSettings",
        },
      ],
      support: [
        {
          name: "customer care",
          icon: "customerCare.svg",
          routeName: null,
        },
        {
          name: "Terms & Condition",
          icon: "terms.svg",
          routeName: null,
        },
        {
          name: "User Guides",
          icon: "terms.svg",
          routeName: "UserGuides",
        },
      ],
      frequently: [
        {
          name: "Transactions",
          icon: "transactions.svg",
          routeName: "Payments",
        },
        {
          name: "Pos",
          icon: "pointOfSale.svg",
          routeName: "Pos",
        },
        {
          name: "Sales History",
          icon: "sales.svg",
          routeName: "SalesHistory",
        },
        {
          name: "Orders",
          icon: "onlineOrders.svg",
          routeName: "Orders",
        },
      ],
    };
  },
  watch: {
    $route(x) {
      if (x) {
        // console.log(this.active);
        // console.log(screen.width < 640 && !this.active);
        // if (screen.width < 640 && this.active) {
        //   this.$emit("toggle", { active: this.active });
        //   console.log("Test");
        // } else if (screen.width < 640 && !this.active) {
        //   console.log(this.active);
        //   this.active = false;
        //   console.log('fnoernvnvgrtngnoergnrengnern');
        //   console.log(this.active);
        //   this.$emit("toggle", { active: this.active });
        // }

        if (!this.active) {
          this.active = false;
        } else {
          this.active = !this.active;
          this.$emit("toggle");
          this.businessServicesToggle = false;
          this.retailStoreToggle = false;
          this.onlineStoreToggle = false;
          this.profileToggle = false;
          this.settingToggle = false;
          this.supportToggle = false;
        }
      }
    },
  },
  created() {
    // this.userPermissions =
    //     permissionsModules[0]["parent"]["permissionsForUser"];
    if (this.authRole !== 'admin') {
      this.businessServices.pop();
      this.profile.pop();
    }
  },
  mounted() {
  },
  computed: {
    getBusinesData() {
      return GET_USER_BUSINESS_ID() !== "60ae21bcb4712a00037a59ab";
    },
  },
  methods: {
    toggle() {
      this.$emit("toggle");
      this.active = !this.active;
    },
    // logoutUser() {
    //   // DELETE_LOCAL_DB_DATA('traction-app-user-data');
    //   // DELETE_LOCAL_DB_DATA('traction-app-current-user-business-data');
    //   localStorage.clear();
    // },
    getImgUrl(pic, name) {
      return require(`../../assets/svg/routes/${name}/${pic}`);
    },
    getImg(pic) {
      return require(`../../assets/svg/${pic}`);
    },
    async logUserOut() {
      if (confirm('Are you sure you wan to log user name out?')) {
        // Clear data in indexedDB
        CLEAR_LIST();
        // localStorage.clear();
        DELETE_AUTH_USER();
        sessionStorage.clear();
        this.$router.replace('/login');
      }
    },
  },
};
</script>

<style scoped>
.increase-spacing-nav {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media print {
  .non-print-slip {
    display: none;
  }
}
</style>
